import { Component, OnInit, ViewChild, ElementRef, OnDestroy, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { CalendarModule } from 'primeng/calendar';
import { FluidModule } from 'primeng/fluid';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { SelectModule } from 'primeng/select';
import { FormsModule } from '@angular/forms';
import { TextareaModule } from 'primeng/textarea';
import { MessageModule } from 'primeng/message';
import { calculateRowAmounts, calculateVatFields, calculateDiscountFields, clampDiscountPercent, round2, isCreditNoteOrder, normalizeCreditNoteQuantity, isCreditLimitCheckEnabledForDivision, resolveCreditRestrictionFromState, isCreditRestrictionActive, shouldSkipCreditLimitOnPicklist, shouldSkipCreditLimitProcessingGate, isCreditLimitApprovedOnOrder, CREDIT_LIMIT_APPROVAL_REASON_MIN_LENGTH, resolveCreditLimit3, applyCustomerCreditFromDetails, isCreditLimitSoftBypassUser, resolveUserEmail, logCreditLimitBypassDebug, CreditLimitDialogData, CreditLimitDialogKind, CreditLimitBypassAction, getCreditLimitBypassContactNote, CreditRestrictionResult, formatCreditLimitDialogNote, mapCreditRestrictionToDialog, extractNoDecPl, resolveQtyDecimalPlaces, isQuantityAllowedByDecimalPlaces, restrictDecimalInputValue, parseLocaleDecimal, resolveLineNoDecPl, resolveDivisionMarginFromItemDetailsResponse, applyMarginFromItemDetailsToLine, applyQuotationPunchLineFromItemDetails, resolveCustomerCountryCodeFromDetails } from './item-utils';
import { RouterModule } from '@angular/router';
import { signal } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Table, TableModule } from 'primeng/table';
import { ViewChildren, QueryList } from '@angular/core';

import { RippleModule } from 'primeng/ripple';

import { ToolbarModule } from 'primeng/toolbar';
import { RatingModule } from 'primeng/rating';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputNumberModule } from 'primeng/inputnumber';
import { DialogModule } from 'primeng/dialog';
import { TagModule } from 'primeng/tag';
import { InputIconModule } from 'primeng/inputicon';
import { IconFieldModule } from 'primeng/iconfield';
import { PanelModule } from 'primeng/panel';
import { ItemDetailsService } from '../services/item-details.service';
import { MarginValidationService } from '../services/margin-validation.service';
import { ProductService } from '../pages/service/product.service'; // ✅ Import this
import { MenuItem } from 'primeng/api';
import { ContextMenu, ContextMenuModule } from 'primeng/contextmenu'; // ✅ Import this
import { CardModule } from 'primeng/card';
import { SplitterModule } from 'primeng/splitter';
import { AppTopbar } from '../layout/component/app.topbar';
import { AutoComplete, AutoCompleteCompleteEvent, AutoCompleteModule } from 'primeng/autocomplete';

import { ToastMessageOptions } from 'primeng/api';

import { FieldsetModule } from 'primeng/fieldset';
import { DividerModule } from 'primeng/divider';
import { ToastModule } from 'primeng/toast';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

import { environment } from '../../environments/environment';
import { Subject } from 'rxjs/internal/Subject';
import { forkJoin, of, from, takeUntil, timeout } from 'rxjs';
import { catchError, map, concatMap, toArray } from 'rxjs/operators';
import { InMemoryStorageService } from '../services/in-memory-storage.service';
import { OrderDraftService } from '../services/order-draft.service';
import { UserService } from '../pages/service/user.service';
import { HeaderInfoComponent } from './header-info/header-info.component';
import { mapCustomerAddressesFromDetails } from './customer-address.util';
import { CreditLimitDialogContentComponent } from './credit-limit-dialog-content/credit-limit-dialog-content.component';
import { MarginApprovalDialogContentComponent } from './margin-approval-dialog-content/margin-approval-dialog-content.component';
import { MarginDialogContentComponent } from './margin-dialog-content/margin-dialog-content.component';
import {
    isMarginApprovalEnabledForDivision,
    buildMarginApprovalSummary,
    syncLineMarginFlags,
    getMarginBypassContactNote,
    getMarginApproverProceedNote,
    getMarginBlockedApprovalNotice,
    isMarginApprovalUserFromStorage,
    resolveMarginAssistanceContactEmails,
    resolveMarginBlockedContactEmails,
    resolveMarginWarehouse,
    resolveOrderMinimumMarginPercent,
    countLinesBelowMinimumMargin,
    MarginApprovalAction,
    isMarginApprovedOnOrder,
    shouldSkipMarginProcessingGate
} from './margin-approval.utils';
import { enrichLinesMarginData, linesNeedMarginEnrichment } from './margin-line-enrichment.util';
import { apiTraceFlow } from '../shared/api-trace';
import {
    applyRunningStockCheck,
    buildStockSaveBlockMessage,
    hasBlockingStockFlags,
    refreshOrderLinesStockErrors
} from './utils/order-line-stock.util';
import { MarginApprovalSummary } from '../services/margin-validation.service';
import { ItemTableComponent } from './item-table/item-table.component';
import { ItemOrderHandlerService } from './item-order-handler.service';
import { CreditNoteSeedLine } from '../dispute-review/dispute.utils';
import { QuotationSeedLine } from '../quotation-review/quotation.utils';
import { UserRole } from '../auth/roles.enum';
import { RoleAccessService } from '../auth/role-access.service';
import { RulesService } from '../services/rules.service';
import { TooltipModule } from 'primeng/tooltip';
import { InvoiceRuleService } from '../services/invoice-rule.service';
import { ArStatementFormComponent } from '../shared/ar-statement-form/ar-statement-form.component';
import { LoaderService } from '../services/loader.service';
import { ArStatementService } from '../services/ArStatementService';
import { ItemBrowsePopupComponent } from '../shared/item-browse-popup/item-browse-popup.component';
import { OldSalesPricePopupComponent } from '../shared/old-sales-price-popup/old-sales-price-popup.component';
@Component({
    standalone: true,
    selector: 'app-item-details',

    imports: [
        AutoCompleteModule,
        ProgressSpinnerModule,
        ToastModule,
        FluidModule,
        DividerModule,
        MessageModule,
        CalendarModule,
        RouterModule,
        FormsModule,
        AutoCompleteModule,
        CommonModule,
        TableModule,
        FieldsetModule,
        PanelModule,
        SplitterModule,
        FormsModule,
        ButtonModule,
        CardModule,
        ContextMenuModule,
        RippleModule,
        ToastModule,
        ToolbarModule,
        RatingModule,
        InputTextModule,
        TextareaModule,
        SelectModule,
        RadioButtonModule,
        InputNumberModule,
        DialogModule,
        TagModule,
        InputIconModule,
        IconFieldModule,
        HeaderInfoComponent,
        CreditLimitDialogContentComponent,
        MarginApprovalDialogContentComponent,
        MarginDialogContentComponent,
        ItemTableComponent,
        TooltipModule,
        ArStatementFormComponent,
        ItemBrowsePopupComponent,
        OldSalesPricePopupComponent
    ],
    providers: [ProductService, MessageService],
    templateUrl: './item-details.component.html',
    styleUrls: ['./item-details.component.scss']
})
export class ItemDetailsComponent implements OnInit, OnDestroy {
    userRoles: UserRole[] = [];
    isReadOnly: boolean = false;
    ruleActiveForDivision: boolean = false;
    private readonly stockCheckExcludedItemNumbers = new Set([
        '27990',
        '27991',
        '27992',
        '27993',
        '27994',
        '27995'
    ]);

    isManagerOrSuperUser: any;
    // selectedWarehouseCountryCode: any;
    // hasShownInvoicePopup = false;
selectedCustomerName: string = '';
selectedCustomerNumber: string = '';
    prefillCustomer: { customerNumber: string; customerName: string; }={ customerNumber: '', customerName: '' };
    showInvoiceConfirm() {
        console.log(this.item.orderMovingStatus);

        // Prevent invoice generation for cancelled orders: status 90 and moving status CAN
        if (this.item.status === 90 && (this.item.orderMovingStatus?.toUpperCase() === 'CAN' || this.item.orderMovingStatus === 'CAN')) {
            this.messageService.add({
                severity: 'warn',
                summary: 'Cannot Generate Invoice',
                detail: 'Invoice cannot be generated for cancelled orders.',
                life: 3000
            });
            return;
        }
        if (this.item.orderMovingStatus?.toUpperCase() === 'CAN' || this.item.orderMovingStatus === 'CAN') {
            this.messageService.add({
                severity: 'warn',
                summary: 'Cannot Generate Invoice',
                detail: 'Invoice cannot be generated for cancelled orders.',
                life: 3000
            });
            return;
        }

        // If already invoiced, go directly to generate-invoice (no preview)
        if (this.item.orderMovingStatus === 'INV') {
            this.generateInvoice();
            return;
        }

        if (this.handleCreditLimitAction('Continue to Invoice Preview', () => this.continueShowInvoiceConfirm(), 'sync')) {
            return;
        }
        this.ensureMarginDataThen(() => {
            if (this.handleMarginApprovalAction('Continue to Invoice Preview', () => this.continueShowInvoiceConfirm(true), 'sync')) {
                return;
            }
            this.continueShowInvoiceConfirm();
        });
    }

    private continueShowInvoiceConfirm(marginApprovalAcknowledged = false): void {
        this.navigateToInvoicePreview(marginApprovalAcknowledged);
    }

    navigateToInvoicePreview(marginApprovalAcknowledged = false) {
        if (this.hasUnsavedLines()) {
            this.messageService.add({
                severity: 'warn',
                summary: 'Save Required',
                detail: 'Please save the order before previewing the invoice.',
                life: 4000
            });
            return;
        }
        this.router.navigate(['/generate-invoice'], {
            state: { item: this.item, itemList: this.itemList, isPreview: true, marginApprovalAcknowledged }
        });
    }
    onDeleteItem($event: number) {
        console.log('Delete item event received from child component:', $event);

        // Call the deleteItem method with the received index
        this.deleteItem($event);
    }
    onDiscountBlurFromChild($event: any) {
        console.log('Discount input blurred in child component:', $event);

        this.onDiscountBlur($event);
    }
    onEditingStateChange(isEditing: boolean) {
        this.isTableInEditMode = isEditing;
    }
    onLineMarginValidationFailed(event: { actual: number; required: number; itemName?: string }) {
        if (!this.isMarginApprovalEnabled) {
            return;
        }
        this.pendingDoneAfterMarginItemWarning = this.isTableInEditMode;
        this.showItemMarginWarningDialog(event.actual, event.required, event.itemName || '');
    }
    onRateBlurFromChild($event: any) {
        console.log('Rate input blurred in child component:', $event);

        this.onRateBlur($event);
    }
    isFocused: boolean = false;
    protected destroy$ = new Subject<void>();
    filter: any;
    loading: boolean = false;
    /** Blocks duplicate Save / Save as Draft while a create/update submit is already running. */
    orderSaveInFlight: boolean = false;
    loaderMessageLine1 = 'Loading...';
    loaderMessageLine2 = 'Please wait...';

    /** Single place for save loading + in-flight flag so retries work after success/error. */
    private setOrderSaveLoading(val: boolean): void {
        this.loading = val;
        if (!val) {
            this.orderSaveInFlight = false;
        }
    }
    @ViewChild('itemNameInput') itemNameInput!: AutoComplete;
    @ViewChild('itemNumberInput') itemNumberInput!: AutoComplete;
    @ViewChild(ItemTableComponent) itemTableComponent?: ItemTableComponent;
    @ViewChildren('discountInputGrid') discountInputs!: QueryList<ElementRef>;
    @ViewChildren('quantityInputGrid') quantityInputsGrid!: QueryList<ElementRef>;
    @ViewChildren('amountInputGrid') amountInputsGrid!: QueryList<ElementRef>;
    @ViewChildren('rateInputGrid') rateInputsGrid!: QueryList<ElementRef>;
    showInfoSection = true;
    showItemBrowsePopup = false;
    showOldSalesPricePopup = false;
    oldSalesPriceItemNo = '';
    itemBrowseSearch = '';
    selectedBrowseRow: any = null;
    product: any;
    customerName: any;

    @HostListener('window:keydown', ['$event'])
    handleItemBrowseShortcut(event: KeyboardEvent) {
        // Only handle F4 without Ctrl/Shift/Alt modifiers to avoid interfering with browser shortcuts
        if (event.key === 'F4' && !event.ctrlKey && !event.shiftKey && !event.altKey) {
            event.preventDefault();
            this.openItemBrowsePopup();
        }
    }
    // warehouses: any[] = [];

    salesPerson: any
    company: string = '';
    division: string = '';
    isTableInEditMode: boolean = false;
    private pendingDoneAfterMarginItemWarning = false;
    ar: number | undefined;
    protected lastFetchedItemDetailsContextKey: string | null = null;

    orderLines: any[] | undefined;
    orderHeaderDisplay:
        | {
              id: any;
              addressCountryCode: any;
              orderId: any;
              companyId: any;
              divisionId: any;
              customerId: any;
              customerName: any;
              addressId: any;
              orderTypeId: any;
              referenceOrderId: any;
              status: any;
              facilityId: any;
              whsId: any;
              requestedDate: any;
              userIdResponsible: any;
              grossValue: any;
              totalDiscountValue: any;
              netAmount: any;
              vatAmount: any;
              orderValue: any;
              address: any;
              name: any;
              totalOverdue: any;
              outstanding: any;
              okcrl3?: any;
              odud?: any;
              nood?: any;
              vatRegistrationNo?: string;
              phoneNumber?: string;
              customerAddress?: string;
              pltb?: string;
              defaultPriceList?: string;
              orderMovingStatus?: string;
              shouldFetchVatPercentage?: boolean;
              txap?: string;
              countryCode?: string;
          }
        | undefined;
    focusDiscountInput(rowIndex: number) {
        setTimeout(() => {
            const inputs = this.discountInputs.toArray();
            if (inputs[rowIndex]) {
                inputs[rowIndex].nativeElement.focus();
            }
        });
    }

    get canOpenItemBrowsePopup(): boolean {
        const movingStatus = this.item?.orderMovingStatus?.toUpperCase();
        return !movingStatus || movingStatus === 'CRT';
    }

    /** Numeric M3 customer number (CUNO); ignores display names stored in customer fields. */
    resolveCustomerId(): string {
        const candidates = [
            this.item?.customerId,
            this.product?.customerId,
            this.item?.customer,
            this.product?.customer
        ];
        for (const candidate of candidates) {
            const value = String(candidate ?? '').trim();
            if (value && /^\d+$/.test(value)) {
                return value;
            }
        }
        return '';
    }

    get hasValidCustomerId(): boolean {
        return this.resolveCustomerId().length > 0;
    }

    get showMissingCustomerBanner(): boolean {
        if (this.loading) {
            return false;
        }
        return !this.readOnly && !this.isReadOnly && !this.hasValidCustomerId;
    }

    /** Returns true when the action must be blocked (blocking dialog is shown). */
    guardMissingCustomerId(_actionLabel: string): boolean {
        if (this.loading) {
            return false;
        }
        return !this.hasValidCustomerId;
    }

    onMissingCustomerGoBack(): void {
        this.goBack();
    }

    onHeaderAddressChanged(): void {
        if (!this.item) {
            return;
        }
        this.product = {
            ...this.product,
            address: this.item.address,
            addressId: this.item.addressId,
            customerAddress: this.item.customerAddress,
            addressCountryCode: this.item.addressCountryCode,
            isCustom: this.item.isCustom,
            customAddress: this.item.customAddress
        };
        this.calculateVatPercentage();
        this.setDraftOrders();
    }

    private mapNumericCustomerIdFromHeader(header: any): string {
        const direct = String(header?.customerId ?? '').trim();
        if (direct && /^\d+$/.test(direct)) {
            return direct;
        }
        const fromCustomer = String(header?.customer ?? '').trim();
        if (fromCustomer && /^\d+$/.test(fromCustomer)) {
            return fromCustomer;
        }
        return '';
    }

    get itemBrowseTooltip(): string {
        if (this.canOpenItemBrowsePopup) {
            return 'Search and select an item (F4)';
        }
        const movingStatus = this.item?.orderMovingStatus?.toUpperCase();
        return `Item browse is only available for orders with CRT status. Current status: ${movingStatus}.`;
    }

    get oldSalesPriceCustomer(): string {
        return String(this.item?.customerId ?? '').trim();
    }

    get oldSalesPriceDivision(): string {
        return String(this.division || this.item?.divisionId || '').trim();
    }

    get oldSalesPriceWarehouse(): string {
        return this.getResolvedWarehouse();
    }

    openOldSalesPricePopup(): void {
        if (!this.oldSalesPriceCustomer) {
            return;
        }
        this.oldSalesPriceItemNo = String(this.itemForm?.itemNumber || '').trim();
        this.showOldSalesPricePopup = true;
    }

    openItemBrowsePopup() {
        if (this.guardMissingCustomerId('browse items')) {
            return;
        }
        // Allow F4 when the order is not yet created in Torna and has no moving status.
        if (!this.canOpenItemBrowsePopup) {
            this.messageService.add({
                severity: 'warn',
                summary: 'Action Not Allowed',
                detail: this.itemBrowseTooltip,
                life: 4000
            });
            return;
        }

        this.selectedBrowseRow = null;
        this.itemBrowseSearch = '';
        this.showItemBrowsePopup = true;
    }

    closeItemBrowsePopup() {
        this.showItemBrowsePopup = false;
    }

    onBrowseSelect(selectedRow: any) {
        console.log('Item Browse selected row:', selectedRow);
        if (selectedRow) {
            const itemName = selectedRow.description || selectedRow.description2 || '';
            const itemNumber = selectedRow.itemNumber || selectedRow.itmno || selectedRow.itmno || '';

            this.itemForm.itemName = itemName;
            this.itemForm.FINALRESPNSE = itemName;
            this.itemForm.itemNumber = itemNumber;

            // Keep search text in sync with the selected item
            this.itemBrowseSearch = itemName;

            // Trigger any change handling for the selected item number
            this.onItemNumberChange();

            // Focus the relevant search field after selection
            setTimeout(() => {
                if (this.itemNameInput?.inputEL) {
                    this.itemNameInput.inputEL.nativeElement.focus();
                } else if (this.itemNumberInput?.inputEL) {
                    this.itemNumberInput.inputEL.nativeElement.focus();
                }
            });
        }
        this.showItemBrowsePopup = false;
    }

    onBrowseRowSelected(row: any) {
        this.selectedBrowseRow = row;
    }

    allLinesSubmitted: boolean = false;
    customerDialogVisible = false;

   isLoadingAR = false;
  openARStatementDialog() {
  // Fallbacks so AR form never gets undefined name (navProduct often has customer but not customerName)
  if (this.selectedCustomerNumber == null || this.selectedCustomerNumber === '') {
    this.selectedCustomerNumber = this.item?.customerId ?? '';
  }
  if (this.selectedCustomerName == null || this.selectedCustomerName === '') {
    this.selectedCustomerName = this.item?.customerName ?? this.customerName ?? '';
  }
  this.prefillCustomer = {
    customerNumber: this.selectedCustomerNumber,
    customerName: this.selectedCustomerName
  };

  this.customerDialogVisible = true;
}

handleARSubmit(payload: {
  payerFrom: string;
  payerTo: string;
  accountingDateFrom: string;
  accountingDateTo: string;
}) {
  console.info('[ORDER] AR submit received', payload);

  this.loaderService.show('Generating AR Statement', 'Please wait...');
  this.isLoadingAR = true;

  this.arStatementService.generate({
    ...payload,
    company: this.userService.getCompanyId(),
    division: this.userService.getDivisionId(),
    warehouse: this.item?.warehouseId || this.item?.whsId || this.item?.warehouse || this.item?.whlo || this.warehouse || ''
  }).subscribe({
    next: () => {
      this.loaderService.hide();
      this.isLoadingAR = false;
      this.customerDialogVisible = false;

      this.messageService.add({
        severity: 'success',
        summary: 'AR Statement Requested',
        detail: 'The AR statement will be sent to your registered email within a few minutes.'
      });
    },
    error: (err) => {
      this.loaderService.hide();
      this.isLoadingAR = false;

      console.error('[ORDER] AR API failed', err);

      this.messageService.add({
        severity: 'error',
        summary: 'Request Failed',
        detail: 'Unable to generate the AR statement. Please try again later.'
      });
    }
  });
}

    focusNextDiscountInput(rowIndex: number) {
        setTimeout(() => {
            const inputs = this.discountInputs.toArray();
            if (inputs[rowIndex + 1]) {
                inputs[rowIndex + 1].nativeElement.focus();
            }
        });
    }

    ngAfterViewInit() {
        setTimeout(() => {
            console.log('Discount inputs available:', this.discountInputs?.length);
        });
    }

    generateInvoice() {
        // Prevent invoice generation for cancelled orders: status 90 and moving status CAN
        if (this.item.status === 90 && (this.item.orderMovingStatus?.toUpperCase() === 'CAN' || this.item.orderMovingStatus === 'CAN')) {
            this.messageService.add({
                severity: 'warn',
                summary: 'Cannot Generate Invoice',
                detail: 'Invoice cannot be generated for cancelled orders.',
                life: 3000
            });
            return;
        }
        if (this.item.orderMovingStatus?.toUpperCase() === 'CAN' || this.item.orderMovingStatus === 'CAN') {
            this.messageService.add({
                severity: 'warn',
                summary: 'Cannot Generate Invoice',
                detail: 'Invoice cannot be generated for cancelled orders.',
                life: 3000
            });
            return;
        }

        localStorage.removeItem('orders');
        localStorage.removeItem('routeParams');
        localStorage.removeItem('orderLines');
        this.orderDraftService.clearDraft();
        console.log(this.hasUnsavedLines());

        if (this.hasUnsavedLines()) {
            console.log('Unsaved changes detected.');

            this.messageService.add({
                severity: 'warn',
                summary: 'Save Required',
                detail: 'Please save the order before generating the invoice.',
                life: 4000
            });
            return;
        }
        this.router.navigate(['/generate-invoice'], {
            state: { item: this.item, itemList: this.itemList }
        });
    }
    canGenerateInvoiceForOrder(): boolean {
  if (!this.item?.orderNumber || this.item.orderNumber === 'New Order') {
    return false;
  }
  if (this.hasUnsavedLines()) {
    return false;
  }
  if (!this.isManagerOrSuperUser) {
    return false;
  }
  return this.invoiceRuleService.canGenerateInvoice(this.item);
    }
    getInvoiceTooltip(): string {
  if (!this.isManagerOrSuperUser) {
    return 'Only managers can generate invoices';
  }
  if (!this.item?.orderNumber || this.item.orderNumber === 'New Order') {
    return 'Save the order first to generate an invoice';
  }
  if (this.hasUnsavedLines()) {
    return 'Please save all lines before invoicing';
  }
  return this.invoiceRuleService.getInvoiceTooltip(this.item);
}
    clear(table: Table) {
        table.clear();
        this.filter.nativeElement.value = '';
    }
    onGlobalFilter(table: Table, event: Event) {
        table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
    }

    item: any;
    editingRowIndex: number | null = null;
    isEditingRates = false;
    @ViewChildren('rateInput') rateInputs!: QueryList<ElementRef>;
    @ViewChild('quantityInput') quantityInput!: ElementRef;
    // @ViewChildren('rateInputGrid') rateInputsGrid!: QueryList<ElementRef>;
    readOnly: boolean = false;
    itemList: any[] = [];
    deletedItems: Map<
        string,
        {
            quantity: number;
            originalQuantity?: number;
            originalQuantityWasSaved?: boolean;
            originalStatus?: number; // ⭐ Add this - tracks original status (10, 20, or 30)
            status: number;
        }[]
    > = new Map();
    itemNames: string[] = []; // populated from localStorage in ngOnInit
    filteredItemNames: string[] = [];
    filteredItemNumbers: string[] = [];
    lockRefreshInterval: any = null;
    itemForm: {
        FINALRESPNSE: string;
        orderNumber?: string;
        lineNumber: string;
        itemName: string;
        itemNumber: string;
        quantity: number;
        rate: number;
        amount: number;
        discount: number;
        amountAfterDiscount: number;
        vat: number;
        vatAmount?: number; // Optional, if you want to calculate VAT amount
        // amountAfterVat?: number; // Optional, if you want to calculate amount after VAT
        amountAfterVat: number;
        vatCode: string;
        grossWeight: number;
        netWeight: number;
        pcs: number;
        size: number;
        itemGroup?: string; // Optional, if you want to include item group
        minrate: number;
        avlStock: number;
        apiStock?: number;
        ar?: number; // Add this line
        cost?: number;
        lineCost?: number;
        minimumMargin?: number;
        calculatedMargin?: number;
        noDecPl?: number;
        marginBelowMinimum?: boolean;
        /** Torna-only recommendation audit (V2); null/omit = legacy. true|false|NO_RECO */
        recommendationWasRecommended?: 'true' | 'false' | 'NO_RECO' | boolean | null;
        recommendationAddSource?: string | null;
        recommendationRank?: number | null;
        recommendationRunId?: string | null;
    } = {
        FINALRESPNSE: '',
        lineNumber: '',
        itemName: '',
        itemNumber: '',
        quantity: 0,
        rate: 0,
        amount: 0,
        discount: 0,
        amountAfterDiscount: 0,
        vat: 7,
        amountAfterVat: 0,
        vatCode: '',
        grossWeight: 0,
        netWeight: 0,
        pcs: 0,
        size: 0,
        itemGroup: '',
        minrate: 0,
        avlStock: 0,
        ar: 0, // Add this line
        cost: 0,
        lineCost: 0,
        minimumMargin: 0,
        calculatedMargin: 0,
        noDecPl: 2,
        marginBelowMinimum: false
    };
    validationError = false;

    private validateItemFormQtyDecimals(): boolean {
        const allowed = resolveQtyDecimalPlaces(this.itemForm.noDecPl ?? extractNoDecPl(this.info), 2);
        if (!isQuantityAllowedByDecimalPlaces(this.itemForm.quantity, allowed)) {
            this.errorMessages.quantity = 'Invalid quantity for this item';
            this.messageService.add({
                severity: 'error',
                summary: 'Invalid quantity',
                detail: `Invalid quantity. Maximum ${allowed} decimal places are allowed for this item.`,
                life: 4000
            });
            return false;
        }
        return true;
    }

    @ViewChild('discountInput') discountInput!: ElementRef;
    @ViewChild('vatInput') vatInput!: ElementRef;
    @ViewChild('submitBtnRef') submitBtnRef!: ElementRef<HTMLButtonElement>;
    @ViewChild('updateBtnRef') updateBtnRef!: ElementRef<HTMLButtonElement>;

    isEditing = false;
    editingIndex: number | null = null;

    dropdownItem = null;
    width: { [klass: string]: any } | null | undefined;

    defaultWarehouses = [
        { name: 'Warehouse', qty: 0 }
        // { name: 'Warehouse2', qty: 0 },
        // { name: 'Warehouse3', qty: 0 }
    ];
    defaultPriceLists = [
        { name: 'PL1', value: 0 },
        { name: 'PL2', value: 0 },
        { name: 'PL3', value: 0 },
        { name: 'NL1', value: 0 },
        { name: 'NL2', value: 0 },
        { name: 'NL3', value: 0 },
        { name: 'FR1', value: 0 },
        { name: 'FR2', value: 0 },
        { name: 'FR3', value: 0 }
    ];
    summary = {
        totalValue: 0,
        totalDiscountValue: 0,
        totalNetAmount: 0,
        totalVatAmount: 0,
        subscription: 0
    };
    onTableChange(updatedList: any[]) {
        this.itemList = updatedList;
        // Trigger recalculation or any other logic here
    }
    onItemListChange(updatedList: any[]) {
        // Replace the reference so Angular detects the change
        this.itemList = updatedList;
        // Optionally, recalculate summary here if needed
    }
    onSummaryChange(summary: any) {
        this.summary = summary;
        // Now you can use this.summary.totalValue, etc. in your parent template
    }
    warehouses = [...this.defaultWarehouses];
    /** Shown PL/NL/FR columns — start empty until pltb/defaultPriceList is known (avoids all 9× 0.00 flashing) */
    priceLists: { name: string; value: number }[] = [];
    info: any = { lastSalePrice: 0 };
    warehouse: any;
    constructor(
        private inMemoryStorageService: InMemoryStorageService,
        private messageService: MessageService,
        private route: ActivatedRoute,
        private router: Router,
        private productService: ProductService,
        private orderDraftService: OrderDraftService,
        private inMemoryStorage: InMemoryStorageService, // <-- Add this
        // private invoiceService: InvoiceService, // Uncomment and set correct service
        private http: HttpClient, // Import HttpClient for API calls
        private itemDetailsService: ItemDetailsService,
        private marginValidationService: MarginValidationService, // ✅ NEW: Margin validation
        private userService: UserService, // Inject UserService
        private itemOrderHandler: ItemOrderHandlerService,
        private roleAccessService: RoleAccessService,
        private rulesService: RulesService,
        private invoiceRuleService: InvoiceRuleService,
        private loaderService: LoaderService,
         public arStatementService: ArStatementService
    ) {}

    confirmDialogVisible: boolean = false;
    confirmInvoiceDialogVisible = false;
    creditLimitDialogVisible = false;
    wh101OrderTypeWarningVisible = false;
    readonly wh101OrderTypeWarningMessage =
        'Please correct order type. Select either G10 or G11 for warehouse 101.';
    creditLimitBlockedDialogVisible = false;
    creditLimitProceedDialogVisible = false;
    creditLimitProceedLabel = 'Continue';
    private creditLimitProceedCallback: (() => void) | null = null;
    /** Required when approving Sync/Invoice credit override. */
    creditLimitApprovalReason = '';
    creditLimitApprovalSubmitting = false;
    creditLimitProceedBypassAction: CreditLimitBypassAction | null = null;
    creditLimitDialogKind: CreditLimitDialogKind = 'exposure';
    creditLimitDialogData: CreditLimitDialogData | null = null;
    creditLimitDialogNood = 0;
    creditLimitDialogOdud = 0;
    creditLimitContactNote = '';
    /** Set when user confirms over-limit Save as Draft; triggers BLCD=2 before AddOrderHeader. */
    private setCustomerCreditBlockAfterSave = false;
    /** Prevents onHide from clearing setCustomerCreditBlockAfterSave after Yes, Save. */
    private creditLimitSaveConfirmAccepted = false;

    marginItemWarningDialogVisible = false;
    marginItemWarningActual = 0;
    marginItemWarningRequired = 0;
    marginItemWarningItemName = '';

    marginApprovalProceedDialogVisible = false;
    marginApprovalBlockedDialogVisible = false;
    marginApprovalProceedLabel = 'Continue';
    marginApprovalSummary: MarginApprovalSummary | null = null;
    marginApprovalContactNote = '';
    marginApprovalContactEmails: string[] = [];
    marginApprovalBlockedNotice = '';
    marginApprovalProceedNote = getMarginApproverProceedNote();
    marginApprovalReason = '';
    marginApprovalSubmitting = false;
    marginApprovalProceedNeedsApi = false;
    private marginApprovalProceedCallback: (() => void) | null = null;
    private marginApprovalBlockedCallback: (() => void) | null = null;
    marginApprovalAction: MarginApprovalAction = 'save';

    orderMarginDialogVisible = false;
    orderMarginDialogActual = 0;
    orderMarginDialogRequired = 0;

    readonly uca2MaxLength = 20;
    isAddingItem = false;

    private initCompanyDivision() {
        this.company = this.inMemoryStorageService.get('company') || '';
        this.division = this.inMemoryStorageService.get('division') || '';
        console.log('✅ Loaded Division:', this.division);
    }

    private initUserProfile() {
        const userProfile = JSON.parse(this.inMemoryStorageService.get('userProfile') || '{}');
        this.salesPerson = userProfile.userName || 'Unknown';
    }
    orderId: any = '';
    navState: any;
    navProduct: any;
    creditNoteFromDispute: {
        claimNumber: string;
        sourceOrderNumber: string;
        creditOrderTypeId: string;
    } | null = null;
    punchFromQuotation: {
        quotationNumber: string;
        customerId: string;
        warehouse: string;
    } | null = null;

    private quotationPunchPendingLines: any[] | null = null;
    private quotationPunchEnrichmentStarted = false;

    private resetFields(): void {
        console.log('Resetting component state to initial values');
        console.log(`item=${this.item}`);
        console.log(`product=${this.product}`);

        console.log(`Before reset:  navProduct=${this.navProduct}, navState=${this.navState}, orderId=${this.orderId}, itemList length=${this.itemList.length}, orderLines length=${this.orderLines?.length}`);

        this.item = null;
        this.product = null;
        this.navProduct = null;
        this.navState = null;
        this.creditNoteFromDispute = null;
        this.punchFromQuotation = null;
        this.quotationPunchPendingLines = null;
        this.quotationPunchEnrichmentStarted = false;
        this.orderId = null;
        this.itemList = [];
        this.orderLines = [];
        this.userRoles = [];
        this.isManagerOrSuperUser = false;
        this.customerName = '';
        this.priceLists = [];
        console.log('Item Details component state reset');
    }
    draftOrders: any[] = [];
    draftLines: any[] = [];
    draftOrderNum = '';

    ngOnInit() {
        this.deletedItems.clear();
        this.resetFields();
        this.userRoles = JSON.parse(this.inMemoryStorage.get('roleGroup') || '[]');

        this.isReadOnly = this.roleAccessService.isReadOnly(this.userRoles);
        this.isManagerOrSuperUser = this.userRoles?.includes(UserRole.Manager) || this.userRoles?.includes(UserRole.SuperUser);

        this.initCompanyDivision();
        this.initUserProfile();

        this.rulesService.checkRuleForDivision(this.division, 'OUT_OF_STOCK_QTY').subscribe({
            next: (response) => {
                console.log('OUT_OF_STOCK_QTY Rule Response:', response);
                this.ruleActiveForDivision = response;
                console.log('OUT_OF_STOCK_QTY Rule Active:', this.ruleActiveForDivision);
            },
            error: (err) => {
                console.error('Error checking rule:', err);
            }
        });
        this.orderId = this.route.snapshot.paramMap.get('id');
        console.log(`Order ID from route: ${this.orderId}`);
        setTimeout(() => {
            if (this.itemNameInput && this.itemNameInput.inputEL) {
                this.itemNameInput.inputEL.nativeElement.focus();
            } else {
                console.log('Item name input not available yet.');
            }
        }, 500);

        this.navState = window.history.state;
        console.log('Navigation state:', this.navState);
        this.navProduct = this.navState?.product || {};
        this.rehydrateNavProductFromLocalDraftIfNeeded();
        console.log(this.navProduct);
        this.selectedCustomerNumber = this.navProduct.customer;
        this.selectedCustomerName = this.navProduct.customerName;
        console.log(this.selectedCustomerNumber, this.selectedCustomerName);

        const copyFromOrderNumber = this.navState?.copyFromOrderNumber as string | undefined;
        const copyMode = (this.navState?.copyMode as string | undefined) || 'ALL';
        if (copyFromOrderNumber && String(copyFromOrderNumber).trim()) {
            this.loading = true;
            this.loadCopiedOrder(String(copyFromOrderNumber).trim(), copyMode);
            return;
        }

        if (this.navState?.creditNoteFromDispute) {
            this.creditNoteFromDispute = {
                claimNumber: String(this.navState.claimNumber || ''),
                sourceOrderNumber: String(this.navState.sourceOrderNumber || ''),
                creditOrderTypeId: String(this.navState.creditOrderTypeId || 'NT3')
            };
            const seedLines = (this.navState.seedLines || []) as CreditNoteSeedLine[];
            if (this.creditNoteFromDispute.sourceOrderNumber && seedLines.length) {
                this.loading = true;
                this.loadCreditNoteFromDispute(
                    this.creditNoteFromDispute.sourceOrderNumber,
                    this.creditNoteFromDispute.creditOrderTypeId,
                    seedLines
                );
                return;
            }
        }

        if (this.navState?.punchFromQuotation) {
            this.punchFromQuotation = {
                quotationNumber: String(this.navState.quotationNumber || ''),
                customerId: String(this.navState.customerId || ''),
                warehouse: String(this.navState.warehouse || '')
            };
            const seedLines = (this.navState.seedLines || []) as QuotationSeedLine[];
            if (this.punchFromQuotation.customerId && seedLines.length) {
                this.loading = true;
                this.loadOrderFromQuotation(
                    this.punchFromQuotation.customerId,
                    String(this.navState.customerName || ''),
                    this.punchFromQuotation.warehouse,
                    seedLines
                );
                return;
            }
        }

        // Existing-order API load:
        // - Use state.orderNumber when present (edit/view flow from lists)
        // - Else use route :id only when there is no navigation product (refresh/deep link)
        // Do NOT use navProduct.id here; for new-order flow it's a local temp id.
        const hasNavigationProduct = !!this.navProduct && Object.keys(this.navProduct).length > 0;
        const orderNumber = (this.navProduct?.orderNumber || (!hasNavigationProduct ? this.orderId : '') || '')?.toString?.() || '';
        this.warehouse = this.navProduct?.warehouseId || '';
        console.log('Warehouse from stateProduct:', this.warehouse);

        // Try to load from API if orderNumber exists
        if (orderNumber) {
            console.log('Loading order from API with order number:', orderNumber);

            this.loadOrderFromApi(orderNumber);
            return;
        }
        // Step 1: Load from local storage
        this.draftOrders = this.getDraftOrderFromLocalStorage();
        this.draftLines = this.getDraftLinesFromLocalStorage();

        console.log('Loaded draftOrders:', this.draftOrders);
        console.log('Loaded draftLines:', this.draftLines);

        // Step 2: Extract valid order numbers
        const validOrderNumbers = new Set(this.draftOrders.map((order) => order.id));
        console.log('Valid order numbers:', validOrderNumbers);

        // Step 3: Keep only lines that match any valid order number
        this.draftLines = this.draftLines.filter((line) => validOrderNumbers.has(line.orderNumber));

        console.log('Filtered draftLines:', this.draftLines);

        this.draftOrderNum = this.draftOrders[0]?.orderNumber || this.orderId || '';
        console.log(`draftOrderNum:`, this.draftOrderNum);
        // Try to load from navigation state if present
        let stateProduct = this.navProduct;

        if (stateProduct && Object.keys(stateProduct).length > 0) {
            console.log('Loading order from navigation state:', stateProduct);

            this.loadFromNavigationState(stateProduct, this.draftLines);
            // Do NOT return here
        }
        if (Object.keys(this.navProduct).length > 0) {
            // Map navProduct to item and product
            console.log('Loading order from navigation state:', this.navProduct);

            this.product = this.navProduct;

            this.product = stateProduct;

            this.item = {
                ...stateProduct,
                address: stateProduct.address?.label || stateProduct?.address || '',
                addressId: stateProduct.address?.addressId || stateProduct?.addressId || '',
                userName: this.salesPerson,
                whsId: stateProduct.warehouseId,
                customerName: stateProduct.name,
                customerId: stateProduct.customer
            };

            this.item.customerId = this.navProduct.CUNO || this.navProduct.customer || this.navProduct.customerId || (typeof this.navProduct.customer === 'string' && /^\d+$/.test(this.navProduct.customer) ? this.navProduct.customer : '') || '';
            this.item.customerName = this.navProduct.CUNM || this.navProduct.customerName || this.navProduct.name || '';
            this.item.outstanding = this.navProduct.outstanding ?? this.item.outstanding ?? 0;
            this.item.totalOverdue = this.navProduct.totalOverdue ?? this.item.totalOverdue ?? 0;
            this.item.okcrl3 = this.navProduct.okcrl3 ?? this.item.okcrl3;
            this.item.odud = this.navProduct.odud ?? this.item.odud;
            this.item.nood = this.navProduct.nood ?? this.item.nood;
            this.item.creditLimit3 = resolveCreditLimit3({
                okcrl3: this.navProduct.okcrl3 ?? this.item.okcrl3,
                creditLimit3: this.navProduct.creditLimit3 ?? this.item.creditLimit3
            });
            this.customerName = this.item.customerName || 'No customer selected';

            this.setPriceListsByPltb(this.product?.pltb);

            // Set itemNames for autocomplete
            this.itemList = [];
            this.setItemNamesForAutocomplete();

            // Optionally, set VAT from info if available
            this.itemForm = {
                ...this.itemForm,
                vat: this.info.vatPercentage1 ?? 0
            };
            // Save new order to localStorage
            console.log('New order details:', this.item);
            console.log('New order details:', this.product);

            console.log('this.item.addressId:', this.item.addressId);
            console.log('this.product.addressId:', this.product.addressId);
            console.log('this.item.address:', this.item.address);
            console.log('this.product.address:', this.product.address);
            console.log('this.navProduct.addressId:', this.navProduct.addressId);
            console.log('this.navProduct.address:', this.navProduct.address);

            const isUnsavedDraftOrder = !this.item?.orderNumber || this.item?.orderNumber === 'New Order';
            const newOrder = {
                addressCountryCode: this.item?.addressCountryCode || this.navProduct?.addressCountryCode || '',
                orderId: '',
                id: this.item?.id || this.navProduct?.id || '',
                companyId: this.company,
                divisionId: this.division,
                customerId: this.item.customerId,
                customerName: this.item.customerName,
                addressId: this.item.addressId || this.navProduct.addressId || '',
                orderTypeId: this.item.orderTypeId || this.navProduct.orderTypeId || this.navProduct.orderType || '',
                referenceOrderId: this.item.referenceOrderId || this.navProduct.referenceOrderId || '',
                // Local draft/new order should remain editable after refresh.
                status: isUnsavedDraftOrder ? 10 : 20,
                facilityId: this.item.facilityId || this.navProduct.facilityId || this.navProduct.facility || '',
                whsId: this.item.warehouseId || this.navProduct.whsId || this.navProduct.warehouseId || this.item.whsId || '',
                requestedDate: this.item.requestedDate || this.navProduct.requestedDate || '',
                userIdResponsible: this.salesPerson,
                address: this.item.address || this.navProduct.address || '',
                name: this.item.name || this.navProduct.name || '',
                outstanding: this.item.outstanding || this.navProduct.outstanding || 0,
                totalOverdue: this.item.totalOverdue || this.navProduct.totalOverdue || 0,
                creditLimit3: resolveCreditLimit3({
                    okcrl3: this.item.okcrl3 ?? this.navProduct.okcrl3,
                    creditLimit3: this.item.creditLimit3 ?? this.navProduct.creditLimit3
                }),
                okcrl3: this.item.okcrl3 ?? this.navProduct.okcrl3,
                odud: this.item.odud ?? this.navProduct.odud,
                nood: this.item.nood ?? this.navProduct.nood,
                vatAmount: this.item.vatAmount || this.navProduct.vatAmount || 0,
                grossValue: this.item.grossValue || this.navProduct.grossValue || 0,
                totalDiscountValue: this.item.totalDiscountValue || this.navProduct.totalDiscountValue || 0,
                netAmount: this.item.netAmount || this.navProduct.netAmount || 0,
                orderValue: this.item.orderValue || this.navProduct.orderValue || 0,
                customerAddress: this.item.customerAddress || this.navProduct.customerAddress || '',
                isCustom: this.item.isCustom ?? this.navProduct?.isCustom ?? 0,
                customAddress: this.item.customAddress || this.navProduct?.customAddress || '',
                phoneNumber: this.item.phoneNumber || this.navProduct.phoneNumber || '',
                vatRegistrationNo: this.item.vatRegistrationNo || this.navProduct.vatRegistrationNo || '',
                pltb: this.navProduct.pltb || this.item.pltb || '',
                orderMovingStatus: isUnsavedDraftOrder ? '' : this.navProduct.orderMovingStatus || this.item.orderMovingStatus || '',
                defaultPriceList: this.navProduct.defaultPriceList || this.item.defaultPriceList || '',
                countryCode: this.item.countryCode || this.navProduct.countryCode || '',
                shouldFetchVatPercentage: true,
                txap: this.item.txap || this.navProduct.txap || ''
            };
            const routeId = String(this.orderId || this.item?.id || this.navProduct?.id || '');
            const existingLocalDraft = routeId ? this.findLocalDraftByRouteId(routeId) : null;
            const isFirstLandingFromCustomerSearch = !existingLocalDraft || !this.isLocalOnlyDraftOrder(existingLocalDraft);
            if (isFirstLandingFromCustomerSearch) {
                localStorage.setItem('orders', JSON.stringify([newOrder]));
                this.draftOrders = [newOrder];
                this.logCreditExposureState('after navigation state saved to localStorage');
            }

            this.resetForm();
            // Do NOT return here
        }

        // Try to load from draft service if present
        // if (this.orderDraftService.orderHeader) {
        //     console.log('Loading draft order from orderDraftService');

        //     this.loadFromDraftService(this.orderDraftService.orderHeader, this.orderDraftService.orderLines);
        //     return;
        // }

        // Try to load from localStorage draft if present
        if (this.draftOrderNum) {
            if (this.warehouse === undefined || this.warehouse === '') {
                this.warehouse = this.draftOrders[0]?.whsId;
            }
            console.log('Warehouse from draft order:', this.warehouse);
            this.loadFromDraftLocalStorage(this.draftOrders, this.draftLines);
            return;
        }

        // If nothing found, show error
        this.showError('No order found. Please start a new order.');
        this.resetForm();
        // this.calculateVatPercentage();
    }

    // hasUnsavedLines(): boolean {
    //     return this.itemList.some((line) => line.status !== 20);
    // }
    hasUnsavedLines(): boolean {
        const unsavedLines = this.itemList.filter((line) => line.status !== 20);
        const hasUnsaved = unsavedLines.length > 0;
        return hasUnsaved;
    }

    private loadOrderFromApi(orderNumber: string) {
        this.startLockRefresh();
        this.loading = true;
        const orderType = 'CustomerOrder';
        this.itemOrderHandler.getAndProcessOrderHeader({
            orderNumber,
            company: this.company,
            division: this.division,
            orderType,
            loadingSetter: (val) => (this.loading = val),
            productSetter: (product) => {
                this.product = product;
                console.log('Product from order header:', this.product);
            },
            customerNameSetter: (name) => (this.customerName = name),
            itemSetter: (item) => {
                this.item = {
                    ...item,
                    phoneNumber: item.phoneNumber || '',
                    customerAddress: item.address || '',
                    vatRegistrationNo: item.vatRegistrationNo || ''
                };
                console.log('Item from order header:', this.item);
                this.warehouse = item?.whsId;
                this.getPriceInfo();
            },
            fetchOrderLines: () => this.fetchOrderLines(),
            readOnlySetter: (val) => (this.readOnly = val),
            itemNamesSetter: (names) => (this.itemNames = names),
            resetForm: () => this.resetForm(),
            itemList: this.itemList,
            messageHandler: (msg) => this.messageService.add(msg)
        });

        // Lines come from getAndProcessOrderHeader → fetchOrderLines() or matching draft only.
        // Do not map all of localStorage here: it could be []/wrong order and masked the API path.
    }

    /**
     * Hook after copy-order finishes assigning `itemList` (including empty / no-qty modes).
     * V2 overrides to reload recommendations and enrich COPY overlap fields.
     */
    protected afterCopiedOrderLinesLoaded(): void {
        // no-op in V1
    }

    protected loadCopiedOrder(orderNumber: string, copyMode: string = 'ALL'): void {
        const company = this.company;
        const division = this.division;
        const orderType = 'CustomerOrder';
        const today = this.getTodayDateForRequest();

        this.itemDetailsService.getOrderHeader(orderNumber, company, division, orderType).subscribe({
            next: (response: any) => {
                let address = '';
                let phoneNumber = '';
                let customerAddress = '';
                if (response.customerAddressDTOResponse) {
                    const addr = response.customerAddressDTOResponse;
                    address = [addr.addressLine1, addr.addressLine2, addr.addressLine3, addr.addressLine4].filter((line: string) => !!line && line.trim() !== '.').join(', ');
                    phoneNumber = addr.phoneNumber || '';
                    customerAddress = addr.combinedAddress || '';
                }

                this.product = { ...response };
                this.customerName = response.customerName || response.CUNM || response.customer || 'No customer selected';
                this.item = {
                    ...response,
                    userName: response.userDto?.userName,
                    address,
                    phoneNumber,
                    combinedAddress: customerAddress,
                    customerId: response.customerId || response.CUNO || '',
                    customerName: response.customerName || response.CUNM || '',
                    orderNumber: undefined,
                    orderId: undefined
                };
                // Ensure product.name is aligned with customer name for header submission
                this.product.name = this.customerName;
                this.item.orderNumber = 'New Order';
                this.product.orderNumber = 'New Order';
                this.clearCopiedOrderCreditAndSyncFields();
                // Copy-order behavior: always default requested date to today.
                this.item.requestedDate = today;
                this.product.requestedDate = today;
                this.warehouse = response.whsId || response.warehouseId || '';
                this.getPriceInfo();
                this.setPriceListsByPltb(this.product?.pltb || this.item?.pltb);

                this.itemDetailsService.getOrderLines(orderNumber, company, division).subscribe({
                    next: (linesResponse: any) => {
                        const content = linesResponse?.content || [];
                        const referenceOrderId = linesResponse.referenceOrderNumber || '';
                        const syncStatus = linesResponse.status ?? 20;
                        const orderTypeVal = linesResponse.orderType ?? linesResponse.header?.orderType ?? null;
                        const requestedDateVal = linesResponse.requestedDate ?? linesResponse.header?.requestedDate ?? null;
                        const draftOrderKey = String(this.orderId || this.item?.id || this.navProduct?.id || '');
                        this.item.status = 10;
                        this.product.status = 10;
                        this.item.orderMovingStatus = '';
                        this.product.orderMovingStatus = '';

                        let mappedLines: any[] = [];
                        if (Array.isArray(content)) {
                            mappedLines = content.map((item: any) => {
                                const amount = item.grossAmount ?? item.gross ?? 0;
                                const sourceCost =
                                    item?.costPrice != null && item.costPrice !== ''
                                        ? Number(item.costPrice)
                                        : undefined;
                                const sourceMcm =
                                    item?.itemMcm != null && item.itemMcm !== ''
                                        ? Number(item.itemMcm)
                                        : undefined;
                                return {
                                    orderNumber: draftOrderKey,
                                    lineNumber: String(item.lineNo),
                                    itemName: item.itemName || '',
                                    itemNumber: item.itemNo || '',
                                    quantity: item.qty ?? 0,
                                    rate: item.rate ?? 0,
                                    amount,
                                    discountAmount: item.discountVal ?? 0,
                                    discount: item.discount ?? 0,
                                    amountAfterDiscount: item.netAmount ?? 0,
                                    vat: item.vat ?? 0,
                                    vatAmount: item.vatAmount ?? 0,
                                    amountAfterVat: item.lineAmount ?? 0,
                                    pcs: item.pcs,
                                    size: item.size,
                                    itemGroup: item.itemGroup,
                                    netWeight: item.netWeight,
                                    grossWeight: item.grossWeight,
                                    vatCode: item.vatCode,
                                    status: 10,
                                    noDecPl: resolveLineNoDecPl(item, 2),
                                    // Seed from source order; ItemDetails refresh below overwrites when non-zero.
                                    cost: Number.isFinite(sourceCost as number) ? sourceCost : undefined,
                                    minimumMargin: Number.isFinite(sourceMcm as number) ? sourceMcm : undefined,
                                    lineCost:
                                        Number.isFinite(sourceCost as number)
                                            ? round2((sourceCost as number) * Number(item.qty ?? 0))
                                            : undefined,
                                    recommendationAddSource: 'COPY',
                                    recommendationWasRecommended: null,
                                    recommendationRank: null,
                                    recommendationRunId: null
                                };
                            });
                        }

                        if (mappedLines.length === 0) {
                            this.itemList = [];
                            this.setItemNamesForAutocomplete();
                            this.resetForm();
                            this.loading = false;
                            this.afterCopiedOrderLinesLoaded();
                            this.messageService.add({
                                severity: 'success',
                                summary: 'Order copied',
                                detail: 'Order header loaded. No lines to copy. You can add lines manually.',
                                life: 3000
                            });
                            return;
                        }

                        const mode = copyMode || 'ALL';

                        if (mode === 'HEADER_ITEMS_NO_QTY' || mode === 'HEADER_ITEMS_NO_QTY_NO_RATE') {
                            mappedLines = mappedLines.map((line: any) => {
                                const base: any = {
                                    ...line,
                                    quantity: 0,
                                    amount: 0,
                                    discountAmount: 0,
                                    amountAfterDiscount: 0,
                                    vatAmount: 0,
                                    amountAfterVat: 0,
                                    copyOrderStockError: undefined,
                                    avlStock: undefined
                                };
                                if (mode === 'HEADER_ITEMS_NO_QTY_NO_RATE') {
                                    base.rate = 0;
                                    base.discount = 0;
                                }
                                return base;
                            });

                            this.itemList = mappedLines;
                            this.setItemNamesForAutocomplete();
                            this.resetForm();
                            this.loading = false;
                            this.afterCopiedOrderLinesLoaded();
                            this.messageService.add({
                                severity: 'info',
                                summary: 'Order copied',
                                detail:
                                    mode === 'HEADER_ITEMS_NO_QTY'
                                        ? 'Order copied without quantities. Enter quantities and save; stock will be checked as you work.'
                                        : 'Order copied without quantities and rates. Enter quantities and rates, then save.',
                                life: 4000
                            });
                            return;
                        }

                        const cuno = this.item.customerId || '';
                        const whlo = this.item.whsId || this.warehouse || '';

                        apiTraceFlow('COPY_ORDER', {
                            lines: mappedLines.length,
                            company: this.company,
                            division: this.division
                        });

                        const CHUNK_SIZE = 10;
                        const chunks: any[][] = [];
                        for (let i = 0; i < mappedLines.length; i += CHUNK_SIZE) {
                            chunks.push(mappedLines.slice(i, i + CHUNK_SIZE));
                        }

                        const stockLedger: Record<string, number> = {};
                        const applyItemDetailsResult = (line: any, res: any | null) => {
                            if (res) {
                                applyMarginFromItemDetailsToLine(
                                    line,
                                    res,
                                    division,
                                    this.product?.defaultPriceList || this.item?.defaultPriceList || '',
                                    Number(line.quantity ?? 0)
                                );
                            }

                            const itemDetails = res?.ItemDetails;
                            if (itemDetails) {
                                const stcd = itemDetails.STCD ?? itemDetails.AR;
                                if (stcd !== undefined && stcd !== null && stcd !== '') {
                                    line.ar = Number(stcd);
                                }
                            }

                            const itemStockCount = itemDetails?.itemStockCount;
                            const count =
                                itemStockCount !== undefined && itemStockCount !== null ? Number(itemStockCount) : null;
                            const apiStock = count !== null && !isNaN(count) ? count : null;
                            applyRunningStockCheck(
                                line,
                                apiStock,
                                stockLedger,
                                this.ruleActiveForDivision,
                                this.isStockCheckExcluded(line.itemNumber)
                            );
                        };

                        from(chunks).pipe(
                            concatMap((chunkLines, chunkIndex) => {
                                const baseIdx = chunkIndex * CHUNK_SIZE;
                                const calls = chunkLines.map((line: any) =>
                                    this.itemDetailsService.getItemDetails(company, division, {
                                        itno: line.itemNumber,
                                        cuno,
                                        whlo
                                    }, 'COPY_ORDER').pipe(catchError(() => of(null)))
                                );
                                return forkJoin(calls).pipe(
                                    map((stockResults: (any | null)[]) => {
                                        stockResults.forEach((res, idx) => {
                                            const line = mappedLines[baseIdx + idx];
                                            if (line) applyItemDetailsResult(line, res);
                                        });
                                        return chunkIndex;
                                    })
                                );
                            }),
                            toArray()
                        ).subscribe({
                            next: () => {
                                this.itemList = mappedLines;
                                this.refreshMarginFlagsOnItemList();
                                this.setItemNamesForAutocomplete();
                                this.resetForm();
                                this.loading = false;
                                this.afterCopiedOrderLinesLoaded();
                                const hasErrors = mappedLines.some((l: any) => l.copyOrderStockError);
                                this.messageService.add({
                                    severity: hasErrors ? 'warn' : 'success',
                                    summary: 'Order copied',
                                    detail: hasErrors ? 'Order copied. Please fix any lines with stock errors before saving.' : 'Order copied. You can save when ready.',
                                    life: 4000
                                });
                            },
                            error: () => {
                                this.itemList = mappedLines;
                                this.setItemNamesForAutocomplete();
                                this.resetForm();
                                this.loading = false;
                                this.afterCopiedOrderLinesLoaded();
                                this.messageService.add({
                                    severity: 'warn',
                                    summary: 'Order copied',
                                    detail: 'Order copied. Some stock checks failed. Please verify lines before saving.',
                                    life: 4000
                                });
                            }
                        });
                    },
                    error: () => {
                        this.loading = false;
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Failed to load lines',
                            detail: 'Could not load order lines. Please try again.',
                            life: 3000
                        });
                    }
                });
            },
            error: () => {
                this.loading = false;
                this.messageService.add({
                    severity: 'error',
                    summary: 'Order not found',
                    detail: 'Could not find the order. Check the order number and try again.',
                    life: 3000
                });
                // Copy-order UX: return user back to orders list when source order does not exist.
                setTimeout(() => this.router.navigate(['/Orders1']), 300);
            }
        });
    }

    private loadCreditNoteFromDispute(
        sourceOrderNumber: string,
        creditOrderTypeId: string,
        seedLines: CreditNoteSeedLine[]
    ): void {
        const company = this.company;
        const division = this.division;
        const orderType = 'CustomerOrder';
        const today = this.getTodayDateForRequest();

        this.itemDetailsService.getOrderHeader(sourceOrderNumber, company, division, orderType).subscribe({
            next: (response: any) => {
                let address = '';
                let phoneNumber = '';
                let customerAddress = '';
                if (response.customerAddressDTOResponse) {
                    const addr = response.customerAddressDTOResponse;
                    address = [addr.addressLine1, addr.addressLine2, addr.addressLine3, addr.addressLine4]
                        .filter((line: string) => !!line && line.trim() !== '.')
                        .join(', ');
                    phoneNumber = addr.phoneNumber || '';
                    customerAddress = addr.combinedAddress || '';
                }

                this.product = { ...response, orderTypeId: creditOrderTypeId };
                this.customerName = response.customerName || response.CUNM || response.customer || 'No customer selected';
                this.item = {
                    ...response,
                    userName: response.userDto?.userName,
                    address,
                    phoneNumber,
                    combinedAddress: customerAddress,
                    customerId: response.customerId || response.CUNO || '',
                    customerName: response.customerName || response.CUNM || '',
                    orderNumber: undefined,
                    orderId: undefined,
                    orderTypeId: creditOrderTypeId,
                    referenceOrderId: sourceOrderNumber
                };
                this.product.name = this.customerName;
                this.item.orderNumber = 'New Order';
                this.product.orderNumber = 'New Order';
                this.product.orderTypeId = creditOrderTypeId;
                this.product.referenceOrderId = sourceOrderNumber;
                this.item.requestedDate = today;
                this.product.requestedDate = today;
                this.warehouse = response.whsId || response.warehouseId || '';
                this.item.status = 10;
                this.product.status = 10;
                this.item.orderMovingStatus = '';
                this.product.orderMovingStatus = '';
                this.getPriceInfo();
                this.setPriceListsByPltb(this.product?.pltb || this.item?.pltb);

                this.itemDetailsService.getOrderLines(sourceOrderNumber, company, division).subscribe({
                    next: (linesResponse: any) => {
                        const content = linesResponse?.content || [];
                        const apiByOrderLineId = new Map<number, any>();
                        const apiByItem = new Map<string, any>();
                        if (Array.isArray(content)) {
                            for (const row of content) {
                                const lineId = Number(row.orderLineId ?? row.order_line_id ?? 0);
                                if (lineId > 0) {
                                    apiByOrderLineId.set(lineId, row);
                                }
                                const itno = String(row.itemNo || row.itemNumber || '').toUpperCase();
                                if (itno) {
                                    apiByItem.set(itno, row);
                                }
                            }
                        }

                        const draftOrderKey = String(this.orderId || this.item?.id || this.navProduct?.id || '');
                        const mappedLines = seedLines.map((seed, index) => {
                            const api =
                                apiByOrderLineId.get(Number(seed.orderLineId)) ||
                                apiByItem.get(String(seed.itemNumber || '').toUpperCase()) ||
                                {};
                            const rate = Number(seed.rate ?? api.rate ?? 0);
                            const gross = rate * Math.abs(Number(seed.quantity));
                            const line: any = {
                                orderNumber: draftOrderKey,
                                lineNumber: String(index + 1),
                                itemName: seed.itemName || api.itemName || '',
                                itemNumber: seed.itemNumber,
                                quantity: normalizeCreditNoteQuantity(Number(seed.quantity)),
                                rate,
                                amount: gross,
                                discountAmount: api.discountVal ?? 0,
                                discount: api.discount ?? 0,
                                amountAfterDiscount: api.netAmount ?? gross,
                                vat: api.vat ?? 0,
                                vatAmount: api.vatAmount ?? 0,
                                amountAfterVat: api.lineAmount ?? gross,
                                pcs: api.pcs,
                                size: api.size,
                                itemGroup: api.itemGroup,
                                netWeight: api.netWeight,
                                grossWeight: api.grossWeight,
                                vatCode: api.vatCode,
                                status: 10
                            };
                            return calculateRowAmounts(line);
                        });

                        this.itemList = mappedLines;
                        this.setItemNamesForAutocomplete();
                        this.resetForm();
                        this.loading = false;
                        this.messageService.add({
                            severity: 'success',
                            summary: 'Credit note draft',
                            detail: `Draft ready (${creditOrderTypeId}). Review lines, then save.`,
                            life: 4000
                        });
                    },
                    error: () => {
                        this.loading = false;
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Failed to load lines',
                            detail: 'Could not load source order lines.',
                            life: 3000
                        });
                    }
                });
            },
            error: () => {
                this.loading = false;
                this.messageService.add({
                    severity: 'error',
                    summary: 'Order not found',
                    detail: 'Could not load the disputed order.',
                    life: 3000
                });
                setTimeout(() => this.router.navigate(['/dispute-review']), 300);
            }
        });
    }

    private loadOrderFromQuotation(
        customerId: string,
        customerName: string,
        warehouse: string,
        seedLines: QuotationSeedLine[]
    ): void {
        const facilityId = this.inMemoryStorageService.get('facilityId') || '';
        const company = this.company;
        const division = this.division;
        const today = this.getTodayDateForRequest();
        const draftOrderKey = String(this.orderId || this.navProduct?.id || '');

        this.productService.getCustomerDetails(customerId, facilityId).subscribe({
            next: (details: any) => {
                const addresses =
                    Array.isArray(details?.addresses) && details.addresses.length
                        ? details.addresses
                        : details?.addressLine1
                          ? [details]
                          : [];
                const firstAddr = addresses[0] || {};
                const addressId = firstAddr.addressId || '';
                const addressCountryCode = resolveCustomerCountryCodeFromDetails(details, addressId);
                const addressLabel = [firstAddr.addressLine1, firstAddr.addressLine2, firstAddr.addressLine3, firstAddr.addressLine4]
                    .filter((line: string) => !!line && line.trim() !== '.')
                    .join(', ');

                const resolvedName =
                    customerName ||
                    details?.customerName ||
                    details?.CUNM ||
                    details?.addresses?.[0]?.customerName ||
                    customerId;
                const orderTypeId = details?.ortp || details?.orderTypeId || '';
                const whs = warehouse || details?.whlo || this.inMemoryStorageService.get('warehouseId') || '';
                const vatRegistrationNo =
                    (details?.vrno != null && String(details.vrno).trim() !== ''
                        ? String(details.vrno).trim()
                        : '') || '';

                this.customerName = resolvedName;
                this.product = {
                    ...details,
                    customer: customerId,
                    customerId,
                    customerName: resolvedName,
                    name: resolvedName,
                    vatRegistrationNo,
                    address: addressLabel,
                    addressId,
                    addressCountryCode,
                    phoneNumber: firstAddr.phoneNumber || '',
                    customerAddress: firstAddr.combinedAddress || '',
                    facilityId: details?.faci || facilityId,
                    warehouseId: whs,
                    whsId: whs,
                    orderTypeId,
                    orderNumber: 'New Order',
                    status: 10,
                    requestedDate: today,
                    pltb: details?.pltb || '',
                    cucd: details?.cucd || '',
                    defaultPriceList: details?.defaultPriceList || ''
                };
                this.item = { ...this.product };
                this.warehouse = whs;
                this.getPriceInfo();
                this.setPriceListsByPltb(this.product?.pltb || this.item?.pltb);

                const mappedLines = seedLines.map((seed, index) => {
                    const rate = Number(seed.rate ?? 0);
                    const qty = Math.abs(Number(seed.quantity));
                    const gross = rate * qty;
                    const line: any = {
                        orderNumber: draftOrderKey,
                        lineNumber: String(index + 1),
                        itemName: seed.itemName || '',
                        itemNumber: seed.itemNumber,
                        quantity: qty,
                        rate,
                        amount: gross,
                        discountAmount: 0,
                        discount: 0,
                        amountAfterDiscount: gross,
                        vat: 0,
                        vatAmount: 0,
                        amountAfterVat: gross,
                        status: 10,
                        avlStock: undefined,
                        copyOrderStockError: undefined
                    };
                    return calculateRowAmounts(line);
                });

                if (!mappedLines.length) {
                    this.itemList = mappedLines;
                    this.setItemNamesForAutocomplete();
                    this.resetForm();
                    this.loading = false;
                    return;
                }

                this.quotationPunchPendingLines = mappedLines;
                this.quotationPunchEnrichmentStarted = false;
            },
            error: () => {
                this.loading = false;
                this.messageService.add({
                    severity: 'error',
                    summary: 'Customer not found',
                    detail: 'Could not load customer details for this draft order.',
                    life: 4000
                });
                setTimeout(() => this.router.navigate(['/quotation-review']), 300);
            }
        });
    }

    private triggerQuotationPunchEnrichmentIfPending(): void {
        const pending = this.quotationPunchPendingLines;
        if (!pending?.length || this.quotationPunchEnrichmentStarted) {
            return;
        }
        this.quotationPunchEnrichmentStarted = true;
        this.quotationPunchPendingLines = null;
        this.runQuotationPunchLineEnrichment(pending);
    }

    private scheduleQuotationPunchEnrichmentFallback(): void {
        if (!this.quotationPunchPendingLines?.length || this.quotationPunchEnrichmentStarted) {
            return;
        }
        setTimeout(() => this.triggerQuotationPunchEnrichmentIfPending(), 4000);
    }

    private runQuotationPunchLineEnrichment(mappedLines: any[]): void {
        const company = this.company;
        const division = this.division;
        const cuno = this.item?.customerId || this.item?.customer || '';
        const whlo = this.item?.whsId || this.item?.warehouseId || this.warehouse || '';
        const defaultPriceList = this.product?.defaultPriceList || this.item?.defaultPriceList || '';
        const shouldFetchVatPercentage = !!this.product?.shouldFetchVatPercentage;
        const enrichmentCtx = { defaultPriceList, shouldFetchVatPercentage };

        const CHUNK_SIZE = 10;
        const chunks: any[][] = [];
        for (let i = 0; i < mappedLines.length; i += CHUNK_SIZE) {
            chunks.push(mappedLines.slice(i, i + CHUNK_SIZE));
        }

        this.loaderMessageLine1 = 'Loading draft order lines…';
        this.loaderMessageLine2 = 'Please wait…';

        from(chunks)
            .pipe(
                concatMap((chunkLines, chunkIndex) => {
                    const baseIdx = chunkIndex * CHUNK_SIZE;
                    const calls = chunkLines.map((line: any) =>
                        this.itemDetailsService
                            .getItemDetails(company, division, {
                                itno: line.itemNumber,
                                cuno,
                                whlo
                            })
                            .pipe(catchError(() => of(null)))
                    );
                    return forkJoin(calls).pipe(
                        map((results: (any | null)[]) => {
                            results.forEach((res, idx) => {
                                const line = mappedLines[baseIdx + idx];
                                if (line) {
                                    applyQuotationPunchLineFromItemDetails(line, res, enrichmentCtx);
                                }
                            });
                            return chunkIndex;
                        })
                    );
                }),
                toArray()
            )
            .subscribe({
                next: () => {
                    // Ensure Net/VAT/Total are recalculated on every line after rate/vat enrichment.
                    mappedLines.forEach((line) => Object.assign(line, calculateRowAmounts(line)));
                    this.itemList = [...mappedLines];
                    this.setItemNamesForAutocomplete();
                    this.resetForm();
                    this.loading = false;
                    this.setDraftOrders();
                    localStorage.setItem('orderLines', JSON.stringify(this.itemList));
                    const hasErrors = mappedLines.some((l: any) => l.copyOrderStockError);
                    this.messageService.add({
                        severity: hasErrors ? 'warn' : 'success',
                        summary: 'Draft order',
                        detail: hasErrors
                            ? `${this.punchFromQuotation?.quotationNumber || 'Draft order'} loaded with stock warnings. Review lines, then save.`
                            : `Draft order lines ready from ${this.punchFromQuotation?.quotationNumber || 'draft'}. Review and save.`,
                        life: 4500
                    });
                },
                error: () => {
                    mappedLines.forEach((line) => Object.assign(line, calculateRowAmounts(line)));
                    this.itemList = [...mappedLines];
                    this.setItemNamesForAutocomplete();
                    this.resetForm();
                    this.loading = false;
                    this.messageService.add({
                        severity: 'warn',
                        summary: 'Draft order',
                        detail: 'Draft order lines loaded but enrichment failed. Verify rates and stock before saving.',
                        life: 4500
                    });
                }
            });
    }

    protected getTodayDateForRequest(): string {
        const now = new Date();
        const year = now.getFullYear();
        const month = `${now.getMonth() + 1}`.padStart(2, '0');
        const day = `${now.getDate()}`.padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    private loadFromNavigationState(stateProduct: any, draftLines: any[]) {
        console.log('Loading from navigation state:', stateProduct);
        this.product = stateProduct;
        const isCustom =
            stateProduct?.isCustom === 1 ||
            stateProduct?.isCustom === '1' ||
            Number(stateProduct?.isCustom) === 1;
        this.item = {
            ...stateProduct,
            address: stateProduct.address?.label || stateProduct.address || '',
            addressId: stateProduct.address?.addressId || stateProduct.addressId || '',
            userName: this.salesPerson,
            whsId: stateProduct.warehouseId,
            isCustom: isCustom ? 1 : 0,
            customAddress: stateProduct.customAddress || '',
            customerAddress: isCustom ? '' : stateProduct.customerAddress || ''
        };
        this.customerName = stateProduct.CUNM || stateProduct.customerName || stateProduct.customer || 'No customer selected';
        this.item.customerId = stateProduct.CUNO || stateProduct.customerId || (typeof stateProduct.customer === 'string' && /^\d+$/.test(stateProduct.customer) ? stateProduct.customer : '') || '';
        this.item.customerName = stateProduct.CUNM || stateProduct.customerName || stateProduct.customer || '';
        this.itemForm = { ...this.itemForm, vat: this.info.vatPercentage1 ?? 0 };
        this.setPriceListsByPltb(this.product?.pltb);
        console.log(draftLines.length);
        if (draftLines && draftLines.length > 0) {
            console.log('Draft lines found:', draftLines);
            this.itemList = draftLines && draftLines.length ? this.mapLinesToItemList(draftLines) : [];
            this.refreshMarginFlagsOnItemList();
            this.setItemNamesForAutocomplete();
        }
        // this.itemList = draftLines && draftLines.length ? this.mapLinesToItemList(draftLines) : [];
        // this.setPriceListsByPltb(this.product?.pltb);
        // this.setItemNamesForAutocomplete();
        this.resetForm();
        this.logCreditExposureState('after loadFromNavigationState');
    }

    private loadFromDraftService(headerArr: any[], linesArr: any[]) {
        console.log('Loading from orderDraftService:', headerArr, linesArr);
        const header = headerArr[0];
        this.orderHeaderDisplay = this.mapHeaderToDisplay(header);
        this.item = this.mapHeaderToItem(header);
        this.getPriceInfo();
        this.setPriceListsByPltb(this.item?.pltb);
        this.orderLines = linesArr || [];
        this.itemList = this.mapLinesToItemList(this.orderLines);
        this.refreshMarginFlagsOnItemList();
        this.setItemNamesForAutocomplete();
        this.resetForm();
    }

    private loadFromDraftLocalStorage(headerArr: any[], linesArr: any[]) {
        console.log('Loading from localStorage draft:', headerArr, linesArr);
        const header = headerArr[0];
        this.orderHeaderDisplay = this.mapHeaderToDisplay(header);
        this.item = this.mapHeaderToItem(header);
        this.getPriceInfo();
        this.setPriceListsByPltb(this.item?.pltb);
        this.orderLines = linesArr || [];
        this.itemList = this.mapLinesToItemList(this.orderLines);
        this.refreshMarginFlagsOnItemList();
        this.setItemNamesForAutocomplete();
        this.resetForm();
        this.logCreditExposureState('after loadFromDraftLocalStorage');
    }

    private mapHeaderToDisplay(header: any) {
        return {
            id: header.id || '',
            addressCountryCode: header.addressCountryCode || '',
            orderId: header.orderId || header.orderID || '',
            companyId: header.companyId || header.company || '',
            divisionId: header.divisionId || header.division || '',
            customerId: this.mapNumericCustomerIdFromHeader(header),
            customerName: header.name || header.customerName || '',
            addressId: header.addressId || '',
            orderTypeId: header.orderTypeId || header.orderType || '',
            referenceOrderId: header.referenceOrderId || '',
            status: header.status || 0,
            facilityId: header.facilityId || header.facility || '',
            whsId: header.whsId || header.warehouseId || '',
            requestedDate: header.requestedDate || '',
            userIdResponsible: header.userIdResponsible || '',
            grossValue: header.grossValue || '',
            totalDiscountValue: header.totalDiscountValue || '',
            netAmount: header.netAmount || '',
            vatAmount: header.vatAmount || '',
            orderValue: header.orderValue || '',
            address: header.address || '',
            name: header.name || '',
            totalOverdue: header.totalOverdue || 0,
            creditLimit3: resolveCreditLimit3(header),
            okcrl3: header.okcrl3,
            odud: header.odud,
            nood: header.nood,
            outstanding: header.outstanding || 0,
            vatRegistrationNo: header.vatRegistrationNo || '',
            phoneNumber: header.phoneNumber || '',
            customerAddress: header.customerAddress || '',
            isCustom: header.isCustom ?? 0,
            customAddress: header.customAddress || '',
            orderMovingStatus: header.orderMovingStatus || '',
            pltb: header.pltb || '',
            defaultPriceList: header.defaultPriceList || '',
            shouldFetchVatPercentage: header.shouldFetchVatPercentage || false,
            txap: header.txap || '',
            countryCode: header.countryCode || '',
            m3LowestStatus: header.m3LowestStatus || '',
            m3HighestStatus: header.m3HighestStatus || ''
        };
    }

    private mapHeaderToItem(header: any) {
        return {
            ...this.mapHeaderToDisplay(header),
            orderNumber: header.orderNumber || header.orderId || header.orderID || '',
            userName: header.userIdResponsible || '',
            warehouse: header.whsId || '',
            facility: header.facilityId || ''
        };
    }

    private mapLinesToItemList(lines: any[]) {
        return (lines ?? []).map((item: any) => {
            const gross = round2((item.qty ?? item.quantity ?? 0) * (item.rate ?? 0));
            const discountVal = item.discountAmount || 0;
            const net = round2(gross - discountVal);
            const vat = item.vat ?? item.vatPersentage ?? 0;
            const vatAmount = round2((net * vat) / 100);
            const lineAmount = round2(net + vatAmount);
            console.log(item);

            const mappedItem: any = {
                lineNumber: item.lineNo?.toString() || item.lineNumber?.toString() || '',
                orderNumber: item.orderNumber || '',
                itemName: item.itemName,
                itemNumber: item.itemNo ?? item.itemNumber,
                quantity: item.qty ?? item.quantity,
                rate: item.rate,
                amount: gross,
                discountAmount: discountVal,
                discount: item.discount,
                amountAfterDiscount: net,
                vat: item.vat,
                vatAmount: vatAmount,
                amountAfterVat: lineAmount,
                pcs: item.pcs,
                size: item.size,
                itemGroup: item.itemGroup,
                netWeight: item.netWeight,
                grossWeight: item.grossWeight,
                vatCode: item.vatCode,
                status: item.status,
                minrate: item.minrate,
                avlStock: item.avlStock,
                apiStock: item.apiStock,
                ar: item.ar !== undefined ? item.ar : item.AR !== undefined ? item.AR : undefined, // ⭐ Add ar property (check both ar and AR)
                noDecPl: resolveLineNoDecPl(item, 2),
                originalQuantity: undefined as number | undefined,
                originalQuantityWasSaved: undefined as boolean | undefined,
                originalStatus: undefined as number | undefined, // ⭐ Add this
                cost: item.cost ?? item.costPrice,
                lineCost:
                    item.lineCost != null
                        ? Number(item.lineCost)
                        : round2((Number(item.cost ?? item.costPrice) || 0) * (item.qty ?? item.quantity ?? 0)),
                minimumMargin: item.minimumMargin ?? item.itemMcm,
                calculatedMargin: item.calculatedMargin,
                marginBelowMinimum: item.marginBelowMinimum === true,
                recommendationWasRecommended: (() => {
                    const v = item.recommendationWasRecommended;
                    if (v === true || v === 'true' || v === '1') {
                        return 'true';
                    }
                    if (v === false || v === 'false' || v === '0') {
                        return 'false';
                    }
                    if (typeof v === 'string' && v.trim().toUpperCase() === 'NO_RECO') {
                        return 'NO_RECO';
                    }
                    return null;
                })(),
                recommendationAddSource: item.recommendationAddSource ?? null,
                recommendationRank:
                    item.recommendationRank != null && Number.isFinite(Number(item.recommendationRank))
                        ? Number(item.recommendationRank)
                        : null,
                recommendationRunId: item.recommendationRunId ?? null
            };

            // ⭐ Track originalQuantity for saved items (status 20)
            if (item.status === 20) {
                mappedItem.originalQuantity = item.quantity;
                mappedItem.originalQuantityWasSaved = true;
                mappedItem.originalStatus = 20; // ⭐ Mark original status as 20 (saved)
            } else if (item.originalQuantity !== undefined) {
                // Preserve originalQuantity and originalStatus if they already exist
                mappedItem.originalQuantity = item.originalQuantity;
                mappedItem.originalQuantityWasSaved = item.originalQuantityWasSaved !== undefined ? item.originalQuantityWasSaved : false;
                mappedItem.originalStatus = item.originalStatus !== undefined ? item.originalStatus : item.status === 10 ? 10 : undefined; // ⭐ Preserve or infer originalStatus
            }

            return mappedItem;
        });
    }

    /**
     * Resolves which price-list family (NL / PL / FR) to show from pltb, then defaultPriceList name, then API row names.
     * RCA for “PL1..FR3 all 0.00 visible”: initial state was all 9 rows; setPriceListsByPltb only ran for exact pltb
     * and was skipped when pltb was missing/unknown or when loadFromNavigationState had no draft lines.
     */
    private inferPriceListFamily(
        pltb?: string | null,
        defaultPriceList?: string | null,
        listsFromApi?: { name: string }[] | null
    ): 'NL' | 'PL' | 'FR' | null {
        const p = (pltb || '').trim();
        if (p === 'GFT_NL_01') {
            return 'NL';
        }
        if (p === 'GFT01' || p === 'GFT02') {
            return 'PL';
        }
        if (p === 'GFT_FR_01') {
            return 'FR';
        }
        const dpl = (defaultPriceList || '').trim().toUpperCase();
        if (dpl.startsWith('NL')) {
            return 'NL';
        }
        if (dpl.startsWith('PL')) {
            return 'PL';
        }
        if (dpl.startsWith('FR')) {
            return 'FR';
        }
        if (listsFromApi?.length) {
            const names = listsFromApi.map((l) => (l.name || '').toUpperCase());
            if (names.every((n) => n.startsWith('NL'))) {
                return 'NL';
            }
            if (names.every((n) => n.startsWith('PL'))) {
                return 'PL';
            }
            if (names.every((n) => n.startsWith('FR'))) {
                return 'FR';
            }
        }
        return null;
    }

    /** Sets priceLists to the 3 placeholders for NL, PL, or FR; empty array if family unknown */
    protected setPriceListsByPltb(pltb?: string | null) {
        const fam = this.inferPriceListFamily(pltb ?? this.product?.pltb ?? this.item?.pltb, this.product?.defaultPriceList ?? this.item?.defaultPriceList, null);
        if (fam === 'NL') {
            this.priceLists = this.defaultPriceLists.filter((pl) => pl.name.startsWith('NL')).map((pl) => ({ ...pl }));
        } else if (fam === 'PL') {
            this.priceLists = this.defaultPriceLists.filter((pl) => pl.name.startsWith('PL')).map((pl) => ({ ...pl }));
        } else if (fam === 'FR') {
            this.priceLists = this.defaultPriceLists.filter((pl) => pl.name.startsWith('FR')).map((pl) => ({ ...pl }));
        } else {
            this.priceLists = [];
        }
    }

    protected setItemNamesForAutocomplete() {
        const itemNamesSet = new Set<string>((this.itemList || []).map((order) => order.itemName).filter((name): name is string => !!name));
        this.itemNames = Array.from(itemNamesSet);
        console.log('Item names for autocomplete:', this.itemNames);
    }

    private getDraftOrderFromLocalStorage(): any[] {
        const draftConst = localStorage.getItem('orders');
        return draftConst ? JSON.parse(draftConst) : [];
    }

    private isLocalOnlyDraftOrder(draft: any): boolean {
        const orderNumber = String(draft?.orderNumber || '').trim();
        return !orderNumber || orderNumber === 'New Order';
    }

    private findLocalDraftByRouteId(routeId: string): any | null {
        if (!routeId) {
            return null;
        }
        const orders = this.getDraftOrderFromLocalStorage();
        return orders.find((o) => String(o?.id || '') === String(routeId)) ?? null;
    }

    /**
     * On refresh, history.state.product can still hold the original customer-search product
     * (e.g. address 001) while localStorage has the user's updated draft (e.g. address 002).
     * For local-only drafts, prefer the stored draft when route :id matches draft id.
     */
    private rehydrateNavProductFromLocalDraftIfNeeded(): void {
        try {
            const routeId = this.orderId || this.route.snapshot.paramMap.get('id') || '';
            const draft = this.findLocalDraftByRouteId(routeId);
            if (!draft || !this.isLocalOnlyDraftOrder(draft)) {
                return;
            }

            const synthesized = { ...draft, orderNumber: '' };
            this.navProduct = synthesized;
            this.navState = { ...(this.navState || window.history.state || {}), product: synthesized };
            window.history.replaceState(this.navState, '');
            console.log('Rehydrated navProduct from localStorage draft for routeId:', routeId);
        } catch (e) {
            console.warn('Failed to rehydrate navProduct from localStorage draft:', e);
        }
    }

    private getDraftLinesFromLocalStorage(): any[] {
        const draftLines = localStorage.getItem('orderLines');
        return draftLines ? JSON.parse(draftLines) : [];
    }

    private showError(msg: string) {
        this.messageService.add({
            severity: 'error',
            summary: 'Order Error',
            detail: msg
        });
        console.error(msg);
    }

    /** Label for the save button: "Save as Draft" for divisionsToProcessImmediately, "Save Order" otherwise */
   get saveOrderButtonLabel(): string {
    const divisionId = this.division || this.userService.getDivisionId?.() || '';
    const immediateDivisions = (environment.divisionsToProcessImmediately || '').split(',').map((d) => d.trim());
    return immediateDivisions.includes(divisionId) ? 'Save as Draft' : 'Save Order';
   }

   /** True when current division is in divisionsToProcessImmediately (e.g. 100). Used to hide Picking List etc. */
   get isImmediateDivision(): boolean {
    const divisionId = this.division || this.userService.getDivisionId?.() || '';
    const immediateDivisions = (environment.divisionsToProcessImmediately || '').split(',').map((d) => d.trim());
    return divisionId !== '' && immediateDivisions.includes(divisionId);
   }

    /** True when OUT_OF_STOCK_QTY + AR=1 lines have insufficient/unverified stock (Excel/copy/grid). */
    get isSaveBlockedByStock(): boolean {
        if (this.isCreditNoteOrder || !this.ruleActiveForDivision) {
            return false;
        }
        return hasBlockingStockFlags(this.itemList, this.getOrderLineStockGuardContext());
    }

    get saveButtonStockBlockTooltip(): string {
        if (this.isTableInEditMode) {
            return 'Exit from edit mode by clicking Done button, then save the order';
        }
        if (this.isSaveBlockedByStock) {
            return 'Fix insufficient or unverified stock lines before saving';
        }
        return '';
    }

    private getOrderLineStockGuardContext() {
        return {
            ruleActiveForDivision: this.ruleActiveForDivision,
            isCreditNoteOrder: this.isCreditNoteOrder,
            isStockCheckExcluded: (itemNumber: unknown) => this.isStockCheckExcluded(itemNumber)
        };
    }

    /**
     * Recompute stock errors and block save when enforced. Soft toast on block.
     * @returns true if save must stop
     */
    protected blockSaveIfStockErrors(messageService: MessageService = this.messageService): boolean {
        if (this.isCreditNoteOrder) {
            return false;
        }
        const blocked = refreshOrderLinesStockErrors(this.itemList, this.getOrderLineStockGuardContext());
        if (!blocked.length) {
            return false;
        }
        messageService.add({
            severity: 'error',
            summary: 'Cannot save',
            detail: buildStockSaveBlockMessage(blocked),
            life: 5000
        });
        return true;
    }

   /** Div 300: picklist open to everyone. Other immediate divisions (e.g. 100) still hide the button. */
   get showPickingListButton(): boolean {
    const divisionId = String(this.division || this.userService.getDivisionId?.() || '').trim();
    if (divisionId === '300') {
      return true;
    }
    return !this.isImmediateDivision;
   }

   private isDivision300(): boolean {
    return String(this.division || this.userService.getDivisionId?.() || '').trim() === '300';
   }

   /** Order-level F1N096 check on save — independent of divisionsToProcessImmediately. */
  get shouldValidateOrderMarginOnSave(): boolean {
    return this.isMarginApprovalEnabled && !this.isCreditNoteOrder && (this.itemList?.length ?? 0) > 0;
  }

   get isMarginApprovalEnabled(): boolean {
    return isMarginApprovalEnabledForDivision(this.division);
   }

   get marginViolationLineCount(): number {
    if (!this.isMarginApprovalEnabled || this.isCreditNoteOrder) {
        return 0;
    }
    return countLinesBelowMinimumMargin(this.itemList);
   }

   get showMarginViolationBanner(): boolean {
    if (isMarginApprovedOnOrder(this.item) || isMarginApprovedOnOrder(this.product)) {
      return false;
    }
    return this.marginViolationLineCount > 0;
   }

   /** Credit note order: 100/G21, 300/F21, 400/N21|NT3|NT4. */
   get isCreditNoteOrder(): boolean {
    const orderTypeId =
      this.item?.orderTypeId ||
      this.product?.orderTypeId ||
      this.product?.orderType ||
      this.navProduct?.orderTypeId ||
      this.navProduct?.orderType ||
      '';
    return isCreditNoteOrder(this.division, orderTypeId);
   }


   get isCreditLimitCheckEnabledForDivision(): boolean {
    const divisionId = this.division || this.userService.getDivisionId?.() || '';
    return isCreditLimitCheckEnabledForDivision(divisionId);
   }
   get isHighOverdueWarning(): boolean {
    return this.overdueRestrictionBanner != null || this.creditExposureBanner != null;
   }

   /** Gate 1: overdue days banner (Credit Limit 4). Shown for overdue-only and when both gates fail. */
   get overdueRestrictionBanner(): { nood: number; odud: number } | null {
    if (this.shouldSkipCreditLimitCheckForOrder() || !this.isCreditLimitCheckEnabledForDivision) {
      return null;
    }
    const restriction = this.getCreditRestrictionState();
    if (restriction.kind !== 'overdue' && restriction.kind !== 'both') {
      return null;
    }
    return { nood: restriction.nood, odud: restriction.odud };
   }

   /** Gate 2: exposure breakdown (Credit Limit 3). Shown for exposure-only and when both gates fail. */
   get creditExposureBanner(): {
    outstanding: number;
    orderValue: number;
    exposureTotal: number;
    creditLimit3: number;
    exceedBy: number;
   } | null {
    if (this.shouldSkipCreditLimitCheckForOrder() || !this.isCreditLimitCheckEnabledForDivision) {
      return null;
    }
    const restriction = this.getCreditRestrictionState();
    if ((restriction.kind !== 'exposure' && restriction.kind !== 'both') || !restriction.exposure) {
      return null;
    }
    const exposure = restriction.exposure;
    return {
      outstanding: exposure.outstanding,
      orderValue: exposure.orderValue,
      exposureTotal: exposure.exposureTotal,
      creditLimit3: exposure.creditLimit3,
      exceedBy: exposure.exceedBy
    };
   }

   protected shouldSkipCreditLimitCheckForOrder(): boolean {
    return shouldSkipCreditLimitProcessingGate(
      this.item?.referenceOrderId ?? this.product?.referenceOrderId,
      this.item ?? this.product
    );
   }

   get creditLimitApprovalBanner(): {
    approvedBy: string;
    approvedAt: string;
    reason: string;
   } | null {
    if (!isCreditLimitApprovedOnOrder(this.item) && !isCreditLimitApprovedOnOrder(this.product)) {
      return null;
    }
    const src = isCreditLimitApprovedOnOrder(this.item) ? this.item : this.product;
    return {
      approvedBy: String(src?.creditLimitApprovedBy ?? '').trim() || '—',
      approvedAt: String(src?.creditLimitApprovedAt ?? '').trim() || '—',
      reason: String(src?.creditLimitApprovalReason ?? '').trim() || '—'
    };
   }

   get marginApprovalBanner(): {
    approvedBy: string;
    approvedAt: string;
    reason: string;
   } | null {
    if (!isMarginApprovedOnOrder(this.item) && !isMarginApprovedOnOrder(this.product)) {
      return null;
    }
    const src = isMarginApprovedOnOrder(this.item) ? this.item : this.product;
    return {
      approvedBy: String(src?.marginApprovedBy ?? '').trim() || '—',
      approvedAt: String(src?.marginApprovedAt ?? '').trim() || '—',
      reason: String(src?.marginApprovalReason ?? '').trim() || '—'
    };
   }

   get canSubmitCreditLimitApproval(): boolean {
    return this.creditLimitApprovalReason.trim().length >= CREDIT_LIMIT_APPROVAL_REASON_MIN_LENGTH;
   }

   get canSubmitMarginApproval(): boolean {
    return this.marginApprovalReason.trim().length >= CREDIT_LIMIT_APPROVAL_REASON_MIN_LENGTH;
   }

   private getResolvedCreditLimit3(): number {
    return resolveCreditLimit3({
      okcrl3: this.item?.okcrl3 ?? this.product?.okcrl3,
      creditLimit3: this.item?.creditLimit3 ?? this.product?.creditLimit3
    });
   }

   private getCurrentOrderValueForCreditCheck(): number {
    const live = this.getSubscription();
    if (live !== 0) {
      return live;
    }
    const saved = Number(this.item?.orderValue ?? this.product?.orderValue);
    return Number.isFinite(saved) ? round2(saved) : 0;
   }

   protected getCreditRestrictionState(): CreditRestrictionResult {
    const outstanding = this.item?.outstanding ?? this.product?.outstanding;
    const orderValue = this.getCurrentOrderValueForCreditCheck();
    const creditLimit3 = this.getResolvedCreditLimit3();
    const nood = this.item?.nood ?? this.product?.nood;
    const odud = this.item?.odud ?? this.product?.odud;
    const totalOverdue = this.item?.totalOverdue ?? this.product?.totalOverdue;
    return resolveCreditRestrictionFromState(
      outstanding,
      orderValue,
      creditLimit3,
      nood,
      odud,
      totalOverdue
    );
   }

   private configureCreditLimitDialog(restriction: CreditRestrictionResult): void {
    const mapped = mapCreditRestrictionToDialog(restriction);
    this.creditLimitDialogKind = mapped.kind;
    this.creditLimitDialogNood = mapped.nood;
    this.creditLimitDialogOdud = mapped.odud;
    this.creditLimitDialogData = mapped.data;
   }

   private isCreditLimitSoftBypassActive(bypassAction: CreditLimitBypassAction): boolean {
    const divisionId = this.division || this.userService.getDivisionId?.() || '';
    const email = resolveUserEmail(this.inMemoryStorageService);
    return isCreditLimitSoftBypassUser(email, divisionId, bypassAction);
   }

   private getResolvedWarehouse(): string {
    return resolveMarginWarehouse({
        warehouseId: this.warehouse ?? this.item?.warehouseId ?? this.product?.warehouseId,
        whsId: this.item?.whsId ?? this.product?.whsId,
        warehouse: this.item?.warehouse ?? this.product?.warehouse,
        storageWarehouseId: this.inMemoryStorageService.get('warehouseId')
    });
   }

   private getOrderMinimumMarginPercent(): number {
    return resolveOrderMinimumMarginPercent({
        orderMcm: this.product?.orderMcm ?? this.item?.orderMcm,
        minimumOrderMargin: this.product?.minimumOrderMargin ?? this.item?.minimumOrderMargin,
        F1N096: this.product?.F1N096 ?? this.item?.F1N096
    });
   }

   protected refreshMarginFlagsOnItemList(): void {
    if (!this.isMarginApprovalEnabled || this.isCreditNoteOrder) {
        return;
    }
    syncLineMarginFlags(this.marginValidationService, this.itemList);
   }

   protected refreshMarginFlagsOnItemListWithEnrichment(): void {
    this.ensureMarginDataThen(() => this.refreshMarginFlagsOnItemList());
   }

   /**
    * @param opts.allowFetch when false (Save / Save as Draft), never call ItemDetails —
    * use cost/MCM already on lines from copy/excel/add. Picklist/invoice may still fetch.
    */
   private ensureMarginDataThen(run: () => void, opts?: { allowFetch?: boolean }): void {
    if (!this.isMarginApprovalEnabled || this.isCreditNoteOrder) {
        run();
        return;
    }
    const allowFetch = opts?.allowFetch !== false;
    if (!allowFetch || !linesNeedMarginEnrichment(this.itemList)) {
        this.refreshMarginFlagsOnItemList();
        run();
        return;
    }
    apiTraceFlow('MARGIN_ENRICH', {
        lines: (this.itemList || []).length,
        company: this.company,
        division: this.division
    });
    enrichLinesMarginData(this.itemDetailsService, this.itemList, {
        company: this.company,
        division: this.division,
        customerId: this.item?.customerId || this.item?.customer || '',
        warehouse: this.item?.warehouseId || this.item?.whsId || this.item?.warehouse || this.item?.whlo || '',
        defaultPriceList: this.product?.defaultPriceList || this.item?.defaultPriceList || ''
    }).subscribe((lines) => {
        this.itemList = [...lines];
        this.refreshMarginFlagsOnItemList();
        run();
    });
   }

   protected buildCurrentMarginApprovalSummary(): MarginApprovalSummary {
    this.refreshMarginFlagsOnItemList();
    return buildMarginApprovalSummary(this.marginValidationService, this.itemList, this.getOrderMinimumMarginPercent());
   }

   private showItemMarginWarningDialog(actual: number, required: number, itemName: string): void {
    this.marginItemWarningActual = actual;
    this.marginItemWarningRequired = required;
    this.marginItemWarningItemName = itemName;
    this.marginItemWarningDialogVisible = true;
   }

   /** Returns true when caller must stop (dialog shown). */
   private handleMarginApprovalAction(
    proceedLabel: string,
    onProceed: () => void,
    action: MarginApprovalAction
   ): boolean {
    if (!this.isMarginApprovalEnabled || this.isCreditNoteOrder) {
        return false;
    }
    if (shouldSkipMarginProcessingGate(
      this.item?.referenceOrderId ?? this.product?.referenceOrderId,
      this.item ?? this.product
    )) {
        return false;
    }
    const summary = this.buildCurrentMarginApprovalSummary();
    if (!summary.hasAnyViolation) {
        return false;
    }
    this.marginApprovalSummary = summary;
    this.marginApprovalAction = action;
    this.marginApprovalContactNote = getMarginBypassContactNote(this.division, this.getResolvedWarehouse(), action);
    const warehouse = this.getResolvedWarehouse();
    if (isMarginApprovalUserFromStorage(this.inMemoryStorageService, this.division, warehouse)) {
        this.marginApprovalContactEmails = resolveMarginAssistanceContactEmails(this.division, warehouse);
        this.marginApprovalProceedLabel = proceedLabel;
        this.marginApprovalProceedNote = getMarginApproverProceedNote(proceedLabel);
        this.marginApprovalReason = '';
        this.marginApprovalSubmitting = false;
        this.marginApprovalProceedNeedsApi = false;
        this.marginApprovalProceedCallback = onProceed;
        this.marginApprovalProceedDialogVisible = true;
        return true;
    }
    this.marginApprovalContactEmails = resolveMarginBlockedContactEmails(
        this.division,
        warehouse,
        resolveUserEmail(this.inMemoryStorageService)
    );
    this.marginApprovalBlockedNotice = getMarginBlockedApprovalNotice(action);
    this.marginApprovalBlockedCallback = action === 'save' ? onProceed : null;
    this.marginApprovalBlockedDialogVisible = true;
    return true;
   }

   onMarginItemWarningDialogClose(): void {
    this.marginItemWarningDialogVisible = false;
    const shouldResumeDone = this.pendingDoneAfterMarginItemWarning;
    this.pendingDoneAfterMarginItemWarning = false;
    if (shouldResumeDone && this.isTableInEditMode && this.itemTableComponent?.isEditingRates) {
        this.itemTableComponent.toggleEditingRates();
    }
   }

   onMarginApprovalProceedCancel(): void {
    this.marginApprovalProceedDialogVisible = false;
    this.marginApprovalProceedCallback = null;
    this.marginApprovalReason = '';
    this.marginApprovalSubmitting = false;
    this.marginApprovalProceedNeedsApi = false;
   }

   onMarginApprovalProceedAccept(): void {
    const cb = this.marginApprovalProceedCallback;
    if (!this.marginApprovalProceedNeedsApi) {
      this.marginApprovalProceedDialogVisible = false;
      this.marginApprovalProceedCallback = null;
      this.marginApprovalReason = '';
      cb?.();
      return;
    }
    if (!this.canSubmitMarginApproval) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Reason required',
        detail: `Enter at least ${CREDIT_LIMIT_APPROVAL_REASON_MIN_LENGTH} characters.`,
        life: 3000
      });
      return;
    }
    const orderNumber = String(this.item?.orderNumber || this.product?.orderNumber || '').trim();
    if (!orderNumber || orderNumber === 'New Order') {
      this.messageService.add({
        severity: 'error',
        summary: 'Cannot approve',
        detail: 'Save the order before approving margin exception.',
        life: 4000
      });
      return;
    }
    this.marginApprovalSubmitting = true;
    this.productService.approveMargin(orderNumber, this.marginApprovalReason.trim()).subscribe({
      next: (res) => {
        this.marginApprovalSubmitting = false;
        if (res?.success === false) {
          this.messageService.add({
            severity: 'error',
            summary: 'Approval failed',
            detail: res?.errorMessage || res?.message || 'Could not save margin approval.',
            life: 5000
          });
          return;
        }
        this.applyMarginApprovalToLocalState(res);
        this.marginApprovalProceedDialogVisible = false;
        this.marginApprovalProceedCallback = null;
        this.marginApprovalReason = '';
        cb?.();
      },
      error: (err) => {
        this.marginApprovalSubmitting = false;
        const msg =
          typeof err?.error === 'string'
            ? err.error
            : err?.error?.errorMessage || err?.error?.message || 'Could not save margin approval.';
        this.messageService.add({ severity: 'error', summary: 'Approval failed', detail: msg, life: 5000 });
      }
    });
   }

   private applyMarginApprovalToLocalState(res?: any): void {
    const approvedBy = res?.marginApprovedBy;
    const approvedAt = res?.marginApprovedAt;
    const reason = res?.marginApprovalReason ?? this.marginApprovalReason.trim();
    const patch = {
      marginApproved: true,
      marginApprovedBy: approvedBy,
      marginApprovedAt: approvedAt,
      marginApprovalReason: reason
    };
    if (this.item) {
      Object.assign(this.item, patch);
    }
    if (this.product) {
      Object.assign(this.product, patch);
    }
   }

   onMarginApprovalBlockedDialogDismiss(): void {
    this.marginApprovalBlockedDialogVisible = false;
    this.marginApprovalBlockedCallback = null;
   }

   onMarginApprovalBlockedDialogOk(): void {
    this.marginApprovalBlockedDialogVisible = false;
    const cb = this.marginApprovalBlockedCallback;
    this.marginApprovalBlockedCallback = null;
    cb?.();
   }

   /** Returns true when caller must stop (dialog shown). */
   private handleCreditLimitAction(
    proceedLabel: string,
    onProceed: () => void,
    bypassAction?: CreditLimitBypassAction
   ): boolean {
    const divisionId = this.division || this.userService.getDivisionId?.() || '';
    if (!this.isCreditLimitCheckEnabledForDivision) {
      return false;
    }
    if (this.shouldSkipCreditLimitCheckForOrder()) {
      return false;
    }
    const restriction = this.getCreditRestrictionState();
    if (!isCreditRestrictionActive(restriction)) {
      return false;
    }
    if (bypassAction) {
      logCreditLimitBypassDebug(`handleCreditLimitAction:${proceedLabel}`, divisionId, this.inMemoryStorageService, bypassAction);
    }
    if (bypassAction && this.isCreditLimitSoftBypassActive(bypassAction)) {
      console.warn('[CreditLimitBypass] showing proceed dialog (soft bypass)', proceedLabel);
      // Sync/Invoice navigation to preview: Continue without reason/API.
      // Approve-with-reason happens on Sync to M3 on the preview screen.
      const dialogBypassAction = bypassAction === 'sync' ? null : bypassAction;
      this.showCreditLimitProceedDialog(proceedLabel, onProceed, restriction, dialogBypassAction ?? undefined);
      return true;
    }
    console.warn('[CreditLimitBypass] sync: allow navigation; hard block on Sync to M3 in preview');
    if (bypassAction === 'sync') {
      onProceed();
      return true;
    }
    this.showCreditLimitBlockedDialog(restriction, bypassAction);
    return true;
   }

   private showCreditLimitProceedDialog(
    proceedLabel: string,
    onProceed: () => void,
    restriction: CreditRestrictionResult,
    bypassAction?: CreditLimitBypassAction
   ): void {
    this.configureCreditLimitDialog(restriction);
    this.creditLimitProceedLabel = proceedLabel;
    this.creditLimitProceedCallback = onProceed;
    this.creditLimitProceedBypassAction = bypassAction ?? null;
    this.creditLimitApprovalReason = '';
    this.creditLimitApprovalSubmitting = false;
    this.creditLimitProceedDialogVisible = true;
   }

   onCreditLimitProceedCancel(): void {
    this.creditLimitProceedDialogVisible = false;
    this.creditLimitProceedCallback = null;
    this.creditLimitProceedBypassAction = null;
    this.creditLimitApprovalReason = '';
    this.creditLimitApprovalSubmitting = false;
   }

   onCreditLimitProceedAccept(): void {
    const cb = this.creditLimitProceedCallback;
    const bypassAction = this.creditLimitProceedBypassAction;
    if (bypassAction === 'sync') {
      if (!this.canSubmitCreditLimitApproval) {
        this.messageService.add({
          severity: 'warn',
          summary: 'Reason required',
          detail: `Enter at least ${CREDIT_LIMIT_APPROVAL_REASON_MIN_LENGTH} characters.`,
          life: 3000
        });
        return;
      }
      const orderNumber = String(this.item?.orderNumber || this.product?.orderNumber || '').trim();
      if (!orderNumber || orderNumber === 'New Order') {
        this.messageService.add({
          severity: 'error',
          summary: 'Cannot approve',
          detail: 'Save the order before approving credit limit.',
          life: 4000
        });
        return;
      }
      this.creditLimitApprovalSubmitting = true;
      this.productService.approveCreditLimit(orderNumber, this.creditLimitApprovalReason.trim()).subscribe({
        next: (res) => {
          this.creditLimitApprovalSubmitting = false;
          if (res?.success === false) {
            this.messageService.add({
              severity: 'error',
              summary: 'Approval failed',
              detail: res?.errorMessage || res?.message || 'Could not save credit approval.',
              life: 5000
            });
            return;
          }
          this.applyCreditLimitApprovalToLocalState(res);
          this.creditLimitProceedDialogVisible = false;
          this.creditLimitProceedCallback = null;
          this.creditLimitProceedBypassAction = null;
          this.creditLimitApprovalReason = '';
          cb?.();
        },
        error: (err) => {
          this.creditLimitApprovalSubmitting = false;
          const msg =
            typeof err?.error === 'string'
              ? err.error
              : err?.error?.errorMessage || err?.error?.message || 'Could not save credit approval.';
          this.messageService.add({ severity: 'error', summary: 'Approval failed', detail: msg, life: 5000 });
        }
      });
      return;
    }
    this.creditLimitProceedDialogVisible = false;
    this.creditLimitProceedCallback = null;
    this.creditLimitProceedBypassAction = null;
    this.creditLimitApprovalReason = '';
    cb?.();
   }

   private applyCreditLimitApprovalToLocalState(res?: any): void {
    const approvedBy = res?.creditLimitApprovedBy;
    const approvedAt = res?.creditLimitApprovedAt;
    const reason = res?.creditLimitApprovalReason ?? this.creditLimitApprovalReason.trim();
    const patch = {
      creditLimitApproved: true,
      creditLimitApprovedBy: approvedBy,
      creditLimitApprovedAt: approvedAt,
      creditLimitApprovalReason: reason
    };
    if (this.item) {
      Object.assign(this.item, patch);
    }
    if (this.product) {
      Object.assign(this.product, patch);
    }
   }

   private showCreditLimitBlockedDialog(
    restriction: CreditRestrictionResult,
    bypassAction?: CreditLimitBypassAction
   ): void {
    this.configureCreditLimitDialog(restriction);
    const divisionId = this.division || this.userService.getDivisionId?.() || '';
    this.creditLimitContactNote = bypassAction
      ? getCreditLimitBypassContactNote(bypassAction, divisionId)
      : '';
    this.creditLimitBlockedDialogVisible = true;
   }

   onCreditLimitBlockedDialogClose(): void {
    this.creditLimitBlockedDialogVisible = false;
   }

   get creditLimitSaveNote(): string {
    return formatCreditLimitDialogNote(
      this.creditLimitDialogKind,
      this.creditLimitDialogNood,
      this.creditLimitDialogOdud,
      this.creditLimitDialogData,
      'Save anyway?'
    );
   }

   get creditLimitProceedNote(): string {
    return formatCreditLimitDialogNote(
      this.creditLimitDialogKind,
      this.creditLimitDialogNood,
      this.creditLimitDialogOdud,
      this.creditLimitDialogData,
      'You may continue.'
    );
   }

   get creditLimitBlockedNote(): string {
    return formatCreditLimitDialogNote(
      this.creditLimitDialogKind,
      this.creditLimitDialogNood,
      this.creditLimitDialogOdud,
      this.creditLimitDialogData,
      '',
      this.creditLimitContactNote
    );
   }

   private logCreditExposureState(context: string): void {
    const restriction = this.getCreditRestrictionState();
    console.log(`[CreditExposure] ${context}`, {
      itemOutstanding: this.item?.outstanding,
      itemOrderValue: this.item?.orderValue,
      itemTotalOverdue: this.item?.totalOverdue,
      itemNood: this.item?.nood,
      itemOdud: this.item?.odud,
      itemCreditLimit3: this.item?.creditLimit3,
      productOutstanding: this.product?.outstanding,
      productOrderValue: this.product?.orderValue,
      productTotalOverdue: this.product?.totalOverdue,
      productNood: this.product?.nood,
      productOdud: this.product?.odud,
      productCreditLimit3: this.product?.creditLimit3,
      restrictionKind: restriction.kind,
      resolvedTotalOverdue: restriction.totalOverdue,
      resolvedNood: restriction.nood,
      resolvedOdud: restriction.odud,
      resolvedExposure: restriction.exposure,
      ruleGate1: 'ODUD > 0 && NOOD >= ODUD',
      ruleGate2: '(outstanding + orderValue) > creditLimit3',
      divisionEnabled: this.isCreditLimitCheckEnabledForDivision,
      showWarning: this.isCreditLimitCheckEnabledForDivision && isCreditRestrictionActive(restriction)
    });
   }

    private buildDraftOrderHeader(): any {
        const routeId = this.route.snapshot.paramMap.get('id') || '';
        const isUnsavedDraftOrder = !this.item?.orderNumber || this.item?.orderNumber === 'New Order';

        return {
            id: this.item?.id || routeId || '',
            orderNumber: this.item?.orderNumber || this.product?.orderNumber || '',
            orderId: this.item?.orderId || '',
            addressCountryCode: this.product?.addressCountryCode || this.item?.addressCountryCode || '',
            companyId: this.company || this.item?.companyId || '',
            divisionId: this.division || this.item?.divisionId || '',
            customerId: this.item?.customerId || this.product?.customerId || '',
            customerName: this.item?.customerName || this.product?.customerName || '',
            addressId: this.item?.addressId || this.product?.addressId || '',
            orderTypeId: this.item?.orderTypeId || this.product?.orderTypeId || this.product?.orderType || '',
            referenceOrderId: this.item?.referenceOrderId || this.product?.referenceOrderId || '',
            status: isUnsavedDraftOrder ? 10 : this.item?.status || this.product?.status || 20,
            facilityId: this.item?.facilityId || this.product?.facilityId || this.product?.facility || '',
            whsId: this.item?.warehouseId || this.product?.whsId || this.product?.warehouseId || this.item?.whsId || '',
            requestedDate: this.item?.requestedDate || this.product?.requestedDate || '',
            userIdResponsible: this.salesPerson,
            address: this.item?.address || this.product?.address || '',
            name: this.item?.name || this.product?.name || '',
            outstanding: this.item?.outstanding ?? this.product?.outstanding ?? 0,
            totalOverdue: this.item?.totalOverdue ?? this.product?.totalOverdue ?? 0,
            creditLimit3: this.getResolvedCreditLimit3(),
            okcrl3: this.item?.okcrl3 ?? this.product?.okcrl3,
            odud: this.item?.odud ?? this.product?.odud,
            nood: this.item?.nood ?? this.product?.nood,
            vatAmount: this.item?.vatAmount || this.product?.vatAmount || 0,
            grossValue: this.item?.grossValue || this.product?.grossValue || 0,
            totalDiscountValue: this.item?.totalDiscountValue || this.product?.totalDiscountValue || 0,
            netAmount: this.item?.netAmount || this.product?.netAmount || 0,
            totalWeight: this.item?.totalWeight || this.product?.totalWeight || 0,
            orderValue: this.item?.orderValue || this.product?.orderValue || 0,
            customerAddress: this.item?.customerAddress || this.product?.customerAddress || '',
            isCustom: this.item?.isCustom ?? this.product?.isCustom ?? 0,
            customAddress: this.item?.customAddress || this.product?.customAddress || '',
            phoneNumber: this.item?.phoneNumber || this.product?.phoneNumber || '',
            vatRegistrationNo: this.item?.vatRegistrationNo || this.product?.vatRegistrationNo || '',
            pltb: this.product?.pltb || this.item?.pltb || '',
            orderMovingStatus: isUnsavedDraftOrder ? '' : this.product?.orderMovingStatus || this.item?.orderMovingStatus || '',
            defaultPriceList: this.product?.defaultPriceList || this.item?.defaultPriceList || '',
            countryCode: this.product?.countryCode || this.item?.countryCode || '',
            shouldFetchVatPercentage: true,
            txap: this.product?.txap || this.item?.txap || '',
            m3LowestStatus: this.item?.m3LowestStatus || this.product?.m3LowestStatus || '',
            m3HighestStatus: this.item?.m3HighestStatus || this.product?.m3HighestStatus || ''
        };
    }

    setDraftOrders() {
        if (!this.item) {
            return;
        }

        const draft = this.buildDraftOrderHeader();
        if (!draft.id) {
            console.warn('setDraftOrders skipped: missing draft id');
            return;
        }

        const orders = JSON.parse(localStorage.getItem('orders') || '[]');
        const idx = orders.findIndex((o: { id?: string }) => String(o?.id || '') === String(draft.id));
        if (idx >= 0) {
            orders[idx] = draft;
        } else {
            orders.push(draft);
        }

        localStorage.setItem('orders', JSON.stringify(orders));
        this.draftOrders = orders.filter((o: { id?: string }) => String(o?.id || '') === String(draft.id));
        console.log('Draft order saved to localStorage:', draft);
    }
    getPriceInfo() {
        console.log('Fetching price info...');

        // SearchCustomer/Details — price lists and live credit (outstanding, totalOverdue, okcrl3, odud, nood)
        const customerId = this.item?.customerId;
        const company = this.company;
        const division = this.division;
        const faci = this.item?.facilityId || this.item?.facility || '100';

        if (customerId && company && division && faci) {
            this.itemDetailsService.getPriceListInfo(customerId, company, division, faci).subscribe({
                next: (resp) => {
                    console.log('resp', resp);
                    const credit = applyCustomerCreditFromDetails(resp);
                    const customerAddressOptions = mapCustomerAddressesFromDetails(resp);
                    const addressCountryCode = resolveCustomerCountryCodeFromDetails(
                        resp,
                        this.item?.addressId || this.product?.addressId
                    );
                    this.item = {
                        ...this.item,
                        outstanding: credit.outstanding,
                        totalOverdue: credit.totalOverdue,
                        okcrl3: credit.okcrl3,
                        creditLimit3: credit.creditLimit3,
                        odud: credit.odud,
                        nood: credit.nood,
                        customerAddressOptions,
                        addressCountryCode: addressCountryCode || this.item?.addressCountryCode || '',
                        countryCode: addressCountryCode || this.item?.countryCode || resp?.addresses?.[0]?.countryCode
                    };
                    this.product = {
                        ...this.product,
                        outstanding: credit.outstanding,
                        totalOverdue: credit.totalOverdue,
                        okcrl3: credit.okcrl3,
                        creditLimit3: credit.creditLimit3,
                        odud: credit.odud,
                        nood: credit.nood,
                        txap: resp?.txap,
                        countryCode: addressCountryCode || resp?.addresses?.[0]?.countryCode,
                        addressCountryCode: addressCountryCode || this.product?.addressCountryCode || '',
                        customerAddressOptions,
                        addresses: Array.isArray(resp?.addresses) ? resp.addresses : this.product?.addresses
                    };
                    this.logCreditExposureState('after SearchCustomer/Details credit');
                    this.fetchWarehouses();
                    this.fetchOrderTypes();
                    console.log(this.product);
                    this.calculateVatPercentage();

                    // Set defaultPriceList and pltb from API response
                    if (resp && resp.defaultPriceList) {
                        this.product = this.product || {};
                        this.product.defaultPriceList = resp.defaultPriceList;
                    }
                    if (resp && resp.pltb) {
                        this.product = this.product || {};
                        this.product.pltb = resp.pltb;
                    }
                    const minimumOrderMargin = Number(resp?.F1N096) || 0;
                    const hasStoredOrderMcm =
                        Number(
                            this.product?.orderMcm ??
                                this.item?.orderMcm ??
                                this.product?.minimumOrderMargin ??
                                this.item?.minimumOrderMargin
                        ) > 0;
                    if (minimumOrderMargin > 0) {
                        if (!hasStoredOrderMcm) {
                            this.product = { ...this.product, minimumOrderMargin, F1N096: resp.F1N096 };
                            this.item = { ...this.item, minimumOrderMargin };
                        } else {
                            this.product = { ...this.product, F1N096: resp.F1N096 };
                        }
                    }
                    console.log('Product from navigation state:1', this.product);
                    this.setPriceListsByPltb(this.product?.pltb);
                    this.setDraftOrders();
                    this.scheduleQuotationPunchEnrichmentFallback();
                },
                error: (err) => {
                    console.warn('Failed to fetch customer details:', err);
                    this.triggerQuotationPunchEnrichmentIfPending();
                }
            });
        }
    }
    selectedWarehouseCountryCode: string = '';
    warehousesForVat: any[] = [];
    orderTypesForHeader: { label: string; value: string }[] = [];

    /** Ensures Bearer token on these calls when interceptor refresh races on page load. */
    protected getAuthOptions(): { headers: { Authorization: string } } | Record<string, never> {
        let token = localStorage.getItem('auth_token') || localStorage.getItem('accessToken');
        if (!token) {
            return {};
        }
        if (token.startsWith('"') && token.endsWith('"')) {
            token = token.slice(1, -1);
        }
        return { headers: { Authorization: `Bearer ${token}` } };
    }

    fetchOrderTypes() {
        const companyId = String(this.inMemoryStorage.get('company') || this.company || '');
        if (!companyId) {
            return;
        }

        const url = `${environment.apiUrl}m3/SearchCustomer/order-type?company=${companyId}`;
        this.http
            .get<{ orderTypes: any[] }>(url, this.getAuthOptions())
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (data) => {
                    this.orderTypesForHeader = (data?.orderTypes ?? []).map((o: any) => ({
                        label: `${o.orderType} - ${o.description}`,
                        value: o.orderType
                    }));
                },
                error: () => {
                    this.orderTypesForHeader = [];
                }
            });
    }

    fetchWarehouses() {
        const companyId = String(this.inMemoryStorage.get('company') || this.company || '');
        console.log('Fetching warehouses for companyId:', companyId);
        if (!companyId) {
            this.triggerQuotationPunchEnrichmentIfPending();
            return;
        }

        this.http
            .get<any[]>(`${environment.apiUrl}facilities/LstWarehouses?company=${companyId}`, this.getAuthOptions())
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (data) => {
                    console.log('Fetched warehouses:', data);
                    console.log('Fetched warehouses:', data);

                    this.warehousesForVat = data.map((w) => ({
                        value: w.whlo, // Store warehouse ID/code
                        label: `${w.whlo} - ${w.whnm}`,
                        cscd: w.cscd // Store country code
                    }));
                    // this.filteredWarehouses = this.warehouses;
                    console.log(this.item.whsId);

                    const orderWarehouse = this.warehousesForVat.find((w) => w.value === this.item.whsId);
                    this.selectedWarehouseCountryCode = orderWarehouse?.cscd || '';
                    console.log('Order warehouse for VAT:', orderWarehouse);
                    console.log(orderWarehouse?.cscd);

                    console.log('Selected warehouse country code:', this.selectedWarehouseCountryCode);
                    this.calculateVatPercentage();
                    this.triggerQuotationPunchEnrichmentIfPending();
                },
                error: () => {
                    this.triggerQuotationPunchEnrichmentIfPending();
                    // this.warehouses = [];
                    // this.filteredWarehouses = [];
                    // this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to load warehouses.' });
                }
            });
    }
    vatPercentage: number = 0;
    calculateVatPercentage() {
        const txap = Number(this.product.txap);
        console.log(this.item.txap, this.product.txap);

        console.log('Calculating VAT percentage with txap:', txap);

        if (txap === 0) {
            this.vatPercentage = 0;
            this.product.shouldFetchVatPercentage = false;
            console.log('VAT Percentage set to 0 due to txap = 0');
            return;
        }

        if (txap === 1) {
            // Get country code from selected address (customer address)
            let customerCountryCode = '';
            console.log('Customer country code from selected address:', customerCountryCode);
            console.log('Customer address details:', this.product.addresses);
            console.log('Selected address:', this.product);
            console.log('Comparing customer and warehouse country codes...', this.item);

            console.log(this.item.addressId, this.product.addressId);
            console.log(this.item.address, this.product.address);
            // console.log(this.item.customerAddressDTOResponse.countryCode);

            console.log(this.product);
            console.log(this.item);
            customerCountryCode = this.product?.addressCountryCode || this.item?.addressCountryCode || this.product?.countryCode || this.item?.countryCode || '';
            if (!customerCountryCode) {
                const addresses = this.product?.addresses || this.item?.addresses;
                const addressId = this.product?.addressId || this.item?.addressId;
                if (Array.isArray(addresses) && addresses.length) {
                    const id = String(addressId ?? '').trim();
                    const selected = id ? addresses.find((a: { addressId?: string }) => String(a?.addressId ?? '').trim() === id) : null;
                    customerCountryCode = String((selected || addresses[0])?.countryCode ?? '').trim();
                }
            }
            // if (this.item.addresses && this.item.addresses.length > 0) {
            //     // const selectedAddress = this.item.addresses.find((a: { addressId: any; }) => a.addressId === this.item.addressId);
            //     customerCountryCode = this.item.customerAddressDTOResponse.countryCode || '';
            //     console.log('Customer country code from selected address:', customerCountryCode);
            // } else {
            //     customerCountryCode = this.item?.customerAddressDTOResponse.countryCode || this.product?.countryCode|| this.item?.countryCode ||'';
            //     console.log('Customer country code from base details:', customerCountryCode);
            // }
            // if (this.item.addressCountryCode ) {
            //     const selectedAddress = this.item.addresses.find((a: { addressId: any }) => a.addressId === this.item.addressId);
            //     customerCountryCode = this.item.customerAddressDTOResponse.countryCode || '';
            //     console.log('Customer country code from customerAddressDTOResponse:', customerCountryCode);
            // } else if (this.orderHeaderDisplay && this.orderHeaderDisplay.countryCode) {
            //     customerCountryCode = this.orderHeaderDisplay.countryCode;
            //     console.log('Customer country code from orderHeaderDisplay:', customerCountryCode);
            // } else if (this.product?.countryCode) {
            //     customerCountryCode = this.product.countryCode;
            //     console.log('Customer country code from product:', customerCountryCode);
            // } else if (this.item?.countryCode) {
            //     customerCountryCode = this.item.countryCode;
            //     console.log('Customer country code from item:', customerCountryCode);
            // } else {
            //     customerCountryCode = '';
            //     console.log('Customer country code not found, defaulting to empty string.');
            // }

            const warehouseCountryCode = this.selectedWarehouseCountryCode;
            console.log('Selected warehouse country code:', warehouseCountryCode);

            if (customerCountryCode && warehouseCountryCode && customerCountryCode === warehouseCountryCode) {
                this.product.shouldFetchVatPercentage = true;
                console.log('shouldFetchVatPercentage', this.product.shouldFetchVatPercentage);
                console.log('Country codes match. VAT percentage API will be called.');
            } else {
                this.product.shouldFetchVatPercentage = false;
                console.log('Country codes do not match. VAT percentage API will not be called.');
                this.vatPercentage = 0;
            }
        }
    }


    calculateAmounts() {
        Object.assign(this.itemForm, calculateRowAmounts(this.itemForm));
    }

    onFormKeyDown(event: KeyboardEvent): void {
        if (event.altKey && event.key === 's') {
            console.log('Alt + S pressed, opening confirmation dialog');

            this.confirmDialogVisible = true;
        }
    }

    errorMessages = {
        quantity: '',
        rate: '',
        discount: '',
        vat: '',
        itemName: '',
        itemno: ''
    };

    submitItem() {
        if (this.guardMissingCustomerId('add lines')) {
            return;
        }
        console.log('🔍 [ITEM VALIDATION] Submit button clicked');

        this.errorMessages = {
            quantity: '',
            itemName: '',
            itemno: '',
            rate: '',
            discount: '',
            vat: ''
        };

        let hasError = false;

        const { quantity, rate, discount, vat, itemNumber, itemName } = this.itemForm;
        // Item Name Validation
        if (!itemName || itemName.trim() === '') {
            console.log('Item Name is invalid:', itemName);
            this.errorMessages.itemName = 'Item Name Required';
            hasError = true;
        }
        // Quantity Validation
        const qtyNum = Number(quantity);
        if (this.isCreditNoteOrder) {
            if (quantity === null || isNaN(qtyNum) || Math.abs(qtyNum) < 0.01) {
                this.errorMessages.quantity = 'Qty Required';
                hasError = true;
            }
        } else if (quantity === null || isNaN(qtyNum) || qtyNum <= 0) {
            this.errorMessages.quantity = 'Qty Required';
            hasError = true;
        }

        // if ((this.itemForm.avlStock === null || isNaN(this.itemForm.avlStock) || this.itemForm.avlStock <= 0) && this.division === '100') {
        if (!this.isCreditNoteOrder && this.ruleActiveForDivision) {
            const isStockExcluded = this.isStockCheckExcluded(this.itemForm.itemNumber);
            if (!isStockExcluded && (this.itemForm.avlStock === null || isNaN(this.itemForm.avlStock) || this.itemForm.avlStock <= 0) && this.ar == 1) {
                this.errorMessages.quantity = 'Out of Stock';

                this.messageService.add({ severity: 'error', summary: 'Out of Stock', detail: `No Stock Available for the selected article` });

                hasError = true;
            } else if (!isStockExcluded && quantity > this.itemForm.avlStock && this.ar == 1) {
                this.errorMessages.quantity = `Max available stock is ${this.itemForm.avlStock}`;
                this.messageService.add({ severity: 'error', summary: 'Stock Limit Exceeded', detail: `Max available stock is ${this.itemForm.avlStock}` });

                hasError = true;
            }
        }

        // if (this.minRate !== 0) {
        //     if (rate < this.minRate) {
        //         this.errorMessages.rate = `Rate must be at least ${Number(this.minRate).toFixed(2)}`;
        //         return;
        //     }
        // }
        // // Rate Validation
        if (rate === null || isNaN(rate) || Number(rate) <= 0) {
            this.errorMessages.rate = 'Rate Required';
            hasError = true;
        }

        // Discount Validation — blank/null treated as 0
        if (this.division === '400') {
            this.itemForm.discount = 0;
        } else {
            const rawDiscount = Number(discount);
            this.itemForm.discount = clampDiscountPercent(discount);
            if (Number.isFinite(rawDiscount) && rawDiscount > 100) {
                this.errorMessages.discount = 'Discount must be between 0 and 100';
                hasError = true;
            }
        }

        // Item No Validation
        if (!itemNumber || itemNumber.trim() === '') {
            this.errorMessages.itemno = 'Item No Required';
            hasError = true;
        }

        if (hasError) {
            console.log('❌ [VALIDATION FAILED] Validation errors:', this.errorMessages);
            return;
        }

        console.log('✅ [BASIC VALIDATION PASSED] All required fields are valid');

        if (!this.validateItemFormQtyDecimals()) {
            return;
        }

        if (this.isAddingItem) {
            return;
        }
        this.isAddingItem = true;

        if (this.isCreditNoteOrder) {
            this.itemForm.quantity = normalizeCreditNoteQuantity(qtyNum);
        }

        const effectiveQty = Number(this.itemForm.quantity);
        const itemNumber_str = String(itemNumber).trim();

        // Calculate amounts (reuse existing logic)
        const gross = round2(effectiveQty * Number(rate));
        const discountValue = round2((gross * Number(discount)) / 100);
        const net = round2(gross - discountValue);
        const vatAmount = round2((net * Number(vat)) / 100);
        const lineAmount = round2(net + vatAmount);

        this.itemForm.amount = gross;
        this.itemForm.amountAfterDiscount = net;
        this.itemForm.vatAmount = vatAmount;
        this.itemForm.amountAfterVat = lineAmount;

        console.log('📊 [AMOUNT CALCULATION]:', { gross, net, discount: discountValue, vat: vatAmount });

        const finishItemAdd = () => {
            if (!this.isCreditNoteOrder) {
                const marginResult = this.validateItemContributionMargin(effectiveQty, net);
                if (!marginResult) {
                    this.releaseAddingItem();
                    return;
                }
                this.itemForm.cost = marginResult.costPrice;
                this.itemForm.lineCost = marginResult.lineCost;
                this.itemForm.minimumMargin = marginResult.minimumContributionMarginPercent;
                this.itemForm.calculatedMargin = marginResult.actualMarginPercent;
                this.itemForm.marginBelowMinimum = marginResult.isBelowMinimum;
            }
            this._completeItemAddition(effectiveQty, rate, discount, vat, net, discountValue, lineAmount);
        };

        if (this.isCreditNoteOrder) {
            finishItemAdd();
            return;
        }

        this.ensureItemMarginInfoForAdd(finishItemAdd);
    }

    /** Load division cost/min margin from API when add-row info is not yet populated (V1 + V2). */
    protected ensureItemMarginInfoForAdd(onReady: () => void): void {
        const currentContextKey = this.currentItemDetailsContextKey();
        const minMargin = Number(this.info?.MFLAMA ?? this.info?.mflama);
        if (this.lastFetchedItemDetailsContextKey === currentContextKey && Number.isFinite(minMargin)) {
            onReady();
            return;
        }
        const itemNo = String(this.itemForm?.itemNumber ?? '').trim();
        if (!itemNo || !this.company || !this.division) {
            onReady();
            return;
        }
        const body = {
            itno: itemNo,
            cuno: this.item?.customerId || this.item?.customer || '',
            whlo: this.item?.warehouseId || this.item?.whsId || this.item?.warehouse || this.item?.whlo || ''
        };
        this.itemDetailsService.getItemDetails(this.company, this.division, body, 'ADD_ITEM_MARGIN').subscribe({
            next: (response: any) => {
                const resolution = resolveDivisionMarginFromItemDetailsResponse(
                    response,
                    this.division,
                    this.product?.defaultPriceList || this.item?.defaultPriceList || ''
                );
                if (resolution) {
                    this.info.MCCSU1 = resolution.cost;
                    this.info.MFLAMA = resolution.minimumMargin;
                } else if (response?.ItemDetails) {
                    this.info.MCCSU1 = response.ItemDetails.MCCSU1;
                    this.info.MFLAMA = response.ItemDetails.MFLAMA;
                }
                this.lastFetchedItemDetailsContextKey = currentContextKey;
                onReady();
            },
            error: () => onReady()
        });
    }

    private releaseAddingItem(): void {
        this.isAddingItem = false;
    }

    /**
     * Complete the item addition after margin validation passes
     * Extracted to avoid code duplication
     */
    private _completeItemAddition(
        effectiveQty: number,
        rate: number,
        discount: number,
        vat: number,
        net: number,
        discountValue: number,
        lineAmount: number
    ): void {
        console.log('🔄 [COMPLETING ITEM ADDITION] Processing item...');

        const nextLineNumber = this.itemList.length > 0 ? Math.max(...this.itemList.map((item) => Number(item.lineNumber))) + 1 : 1;
        console.log(this.item.orderNumber, this.product.orderNumber);
        const orderId = this.route.snapshot.paramMap.get('id');
        const currentOrderNumber = `${this.item?.orderNumber || ''}`.trim();
        const draftOrderKey = currentOrderNumber && currentOrderNumber !== 'New Order' ? currentOrderNumber : `${orderId || ''}`;
        console.log('📋 Order ID from route:', orderId);

        const gross = round2(effectiveQty * rate);

        const line = {
            orderNumber: draftOrderKey,
            lineNo: this.itemForm.lineNumber,
            itemNo: this.itemForm.itemNumber,
            itemName: this.itemForm.itemName,
            qty: this.itemForm.quantity,
            vat: this.itemForm.vat,
            discount: this.itemForm.discount,
            netAmount: this.itemForm.amountAfterDiscount,
            grossAmount: this.itemForm.amount,
            vatAmount: this.itemForm.vatAmount,
            vatPersentage: this.itemForm.vat,
            discountAmount: round2((this.itemForm.amount * this.itemForm.discount) / 100) || 0,
            lineAmount: lineAmount,
            rate: this.itemForm.rate,
            status: 10,
            pcs: this.itemForm.pcs,
            size: this.itemForm.size,
            grossWeight: this.itemForm.grossWeight,
            netWeight: this.itemForm.netWeight,
            vatCode: this.itemForm.vatCode,
            itemGroup: this.itemForm.itemGroup,
            minrate: this.minRate,
            avlStock: this.itemForm.avlStock,
            cost: this.itemForm.cost,
            lineCost: this.itemForm.lineCost,
            minimumMargin: this.itemForm.minimumMargin,
            calculatedMargin: this.itemForm.calculatedMargin,
            apiStock: this.itemForm.apiStock,
            marginBelowMinimum: this.itemForm.marginBelowMinimum === true
        };

        // Retrieve existing lines array or initialize as empty
        const lines = JSON.parse(localStorage.getItem('orderLines') || '[]');
        // Add the new line
        console.log('📝 Adding line to localStorage:', line);
        lines.push(line);

        const newItem = {
            ...this.itemForm,
            orderNumber: draftOrderKey,
            lineNumber: nextLineNumber.toString(),
            amount: gross,
            discountAmount: discountValue,
            amountAfterDiscount: net,
            vatAmount: this.itemForm.vatAmount,
            amountAfterVat: lineAmount,
            status: 10,
            minrate: this.minRate,
            originalStatus: 10,
            cost: this.itemForm.cost,
            lineCost: this.itemForm.lineCost,
            minimumMargin: this.itemForm.minimumMargin,
            calculatedMargin: this.itemForm.calculatedMargin
        };

        console.log('✅ [NEW ITEM CREATED]:', newItem);

        this.itemList = [...this.itemList, newItem];
        console.log('📊 [ITEM LIST UPDATED] Total items:', this.itemList.length);

        localStorage.setItem('orderLines', JSON.stringify(this.itemList));
        if (newItem.itemName && !this.itemNames.includes(newItem.itemName)) {
            this.itemNames.push(newItem.itemName);
        }

        // Only reset additional fields after successful submission
        this.resetAdditionalFields();

        // Reset form after adding the item
        this.resetForm();

        this.headerPanelOpen = false;

        this.showSuccessViaToast();

        this.releaseAddingItem();

        setTimeout(() => {
            if (this.itemNameInput?.inputEL) {
                this.itemNameInput.inputEL.nativeElement.focus();
            }
        });
    }
    /**
     * Selects or deselects all items in the list based on the event.
     * @param event - The event containing the selection state.
     */
    selectAll(event: any) {
        event.target.select();
    }

    /**
     * Clears the item form, resetting all fields to their default values.
     */
    clearItemForm() {

        const currentLineNumber = this.itemForm.lineNumber; // Preserve line number
        this.itemForm = {
            FINALRESPNSE: '',
            orderNumber: '',
            lineNumber: currentLineNumber,
            itemName: '',
            itemNumber: '',
            quantity: 0,
            rate: 0,
            amount: 0,
            discount: 0,
            amountAfterDiscount: 0,
            vat: 0,
            vatAmount: 0,
            amountAfterVat: 0,
            vatCode:'',
            grossWeight:0,
            netWeight:0,
            pcs:0,
            size:0,
            itemGroup: '', // Reset item group if needed
            minrate:0,
            avlStock: 0
        };

        // Optionally clear errors if any
        this.errorMessages = {
            quantity: '',
            itemName: '',
            itemno: '',
            rate: '',
            discount: '',
            vat: ''
        };

        // Focus the first input (optional)
        setTimeout(() => {
            if (this.itemNameInput?.inputEL) {
                this.itemNameInput.inputEL.nativeElement.focus();
            }
        });
    }

    /**
     * Edits an item in the list by populating the form with its details.
     * @param item - The item to edit.
     * @param index - The index of the item in the list.
     */
    editItem(item: any, index: number) {
        this.itemForm = { ...item };
        this.isEditing = true;
        this.editingIndex = index;
    }

    /**
     * Updates the details of the currently edited item.
     */
    updateItem() {
        if (this.editingIndex === null) {
            return;
        }
        if (!this.validateItemFormQtyDecimals()) {
            return;
        }
        this.calculateAmounts();
        if (!this.isCreditNoteOrder) {
            const effectiveQty = Number(this.itemForm.quantity);
            const sellingAmount = Number(this.itemForm.amountAfterDiscount);
            const marginResult = this.validateItemContributionMargin(effectiveQty, sellingAmount);
            if (!marginResult) {
                return;
            }
            this.itemForm.cost = marginResult.costPrice;
            this.itemForm.lineCost = marginResult.lineCost;
            this.itemForm.minimumMargin = marginResult.minimumContributionMarginPercent;
            this.itemForm.calculatedMargin = marginResult.actualMarginPercent;
            this.itemForm.marginBelowMinimum = marginResult.isBelowMinimum;
        }
        this.itemList[this.editingIndex] = { ...this.itemForm };
        this.itemList = [...this.itemList];
        localStorage.setItem('orderLines', JSON.stringify(this.itemList));
        this.cancelEdit();
    }

    private validateItemContributionMargin(
        quantity: number,
        sellingAmount: number
    ): {
        costPrice: number;
        lineCost: number;
        minimumContributionMarginPercent: number;
        actualMarginPercent: number;
        isBelowMinimum: boolean;
    } | null {
        const costPrice = Number(this.info?.MCCSU1 ?? this.info?.mccsu1) || 0;
        const minimumContributionMarginPercent = Number(this.info?.MFLAMA ?? this.info?.mflama) || 0;
        console.log('[MARGIN-DIVISION] validateItemContributionMargin', {
            division: this.division,
            itemNumber: this.itemForm?.itemNumber,
            costUsedForValidation: costPrice,
            marginUsedForValidation: minimumContributionMarginPercent,
            infoMCCSU1: this.info?.MCCSU1,
            infoMFLAMA: this.info?.MFLAMA,
            quantity,
            sellingAmount
        });
        const result = this.marginValidationService.calculateItemContributionMargin(
            costPrice,
            quantity,
            sellingAmount,
            minimumContributionMarginPercent
        );

        if (!result.isValid) {
            if (!this.isMarginApprovalEnabled) {
                return {
                    costPrice,
                    lineCost: result.lineCost,
                    minimumContributionMarginPercent,
                    actualMarginPercent: result.actualMarginPercent,
                    isBelowMinimum: false
                };
            }
            this.showItemMarginWarningDialog(
                result.actualMarginPercent,
                result.minimumMarginPercent,
                this.itemForm.itemName || ''
            );
        }

        return {
            costPrice,
            lineCost: result.lineCost,
            minimumContributionMarginPercent,
            actualMarginPercent: result.actualMarginPercent,
            isBelowMinimum: !result.isValid
        };
    }

    onOrderMarginDialogClose(): void {
        this.orderMarginDialogVisible = false;
    }

    /**
     * Cancels the edit operation and resets the form.
     */
    cancelEdit() {
        this.resetForm();
        this.isEditing = false;
        this.editingIndex = null;
    }

    /**
     * Deletes an item from the list based on its index.
     * @param index - The index of the item to delete.
     */
    // Around line 1350 - Replace deleteItem method
    deleteItem(index: number) {
        console.log('=== deleteItem START ===');
        console.log('Deleting item at index:', index);

        if (index < 0 || index >= this.itemList.length) {
            console.error('Invalid index for deletion');
            return;
        }

        const itemToDelete = this.itemList[index];
        console.log('Item to delete:', JSON.parse(JSON.stringify(itemToDelete)));
        console.log('Item status:', itemToDelete.status);
        console.log('Item quantity:', itemToDelete.quantity);
        console.log('Item originalQuantity:', itemToDelete.originalQuantity);

        // Around line 1359 - Update deleteItem method
        // ⭐ Track deleted item if it was saved (status 20) or edited from saved (status 30 with originalQuantityWasSaved=true)
        if (itemToDelete.status === 20 || (itemToDelete.status === 30 && itemToDelete.originalQuantityWasSaved === true)) {
            const itemNumber = itemToDelete.itemNumber;

            if (!this.deletedItems.has(itemNumber)) {
                this.deletedItems.set(itemNumber, []);
            }

            const deletedItemInfo = {
                quantity: Number(itemToDelete.quantity) || 0,
                originalQuantity: itemToDelete.originalQuantity !== undefined ? Number(itemToDelete.originalQuantity) : itemToDelete.status === 20 ? Number(itemToDelete.quantity) : undefined,
                originalQuantityWasSaved: itemToDelete.originalQuantityWasSaved !== undefined ? itemToDelete.originalQuantityWasSaved : itemToDelete.status === 20 ? true : false,
                status: itemToDelete.status
            };

            this.deletedItems.get(itemNumber)!.push(deletedItemInfo);

            console.log('✅ Tracked deleted item:', deletedItemInfo);
            console.log('Deleted items for', itemNumber, ':', this.deletedItems.get(itemNumber));
        } else if (itemToDelete.status === 10 || (itemToDelete.status === 30 && itemToDelete.originalQuantityWasSaved === false)) {
            console.log('⏭️ Deleted item was status 10 or status 30 (from unsaved), no need to track');
        }

        // Remove item from list
        this.itemList.splice(index, 1);
        this.itemList = [...this.itemList];

        console.log('Updated itemList length:', this.itemList.length);
        console.log('=== deleteItem END ===');

        localStorage.setItem('orderLines', JSON.stringify(this.itemList));
    }
    /**
     * Displays a success message using a toast notification.
     */
    showSuccessViaToast() {
        console.log('showSuccessViaToast called');

        this.messageService.add({ severity: 'success', summary: 'Article Added', detail: 'Article has been successfully added to the Table.', life: 3000 });
    }
    /**
     * Resets the form to its initial state.
     */
    resetForm() {
        console.log('resetForm called');

        const nextLineNumber = this.itemList.length > 0 ? Math.max(...this.itemList.map((item) => Number(item.lineNumber))) + 1 : 1;

        this.itemForm = {
            FINALRESPNSE: '',
            orderNumber: '',
            lineNumber: nextLineNumber.toString(),
            itemName: '',
            itemNumber: '',
            quantity: 0,
            rate: 0,
            amount: 0,
            discount: 0,
            amountAfterDiscount: 0,
            vat: this.info.vatPercentage1 ?? 0,
            amountAfterVat: 0,
            vatCode: this.info.vatCode ?? '',
            grossWeight: this.info.grossWeight ?? 0,
            netWeight: this.info.netWeight ?? 0,
            pcs: this.info.pcs ?? 0,
            size: this.info.size ?? 0,
            itemGroup: this.info.itemGroup ?? '',
            minrate: this.info.minRate ?? 0,
            avlStock: 0,
            ar: 0, // Add this line
            noDecPl: 2
        };
        this.lastFetchedItemDetailsContextKey = null;
    }

    /**
     * Focuses on the next rate input field in the grid.
     * @param currentIndex - The index of the current rate input field.
     */
    focusNextRateInput(currentIndex: number) {
        const inputs = this.rateInputs.toArray();
        const nextInput = inputs[currentIndex + 1];
        if (nextInput) {
            nextInput.nativeElement.focus();
        }
    }

    /**
     * Focuses on the next rate input field in the grid.
     * @param currentIndex - The index of the current rate input field.
     */
    focusNextRateInputGrid(currentIndex: number) {
        setTimeout(() => {
            const inputs = this.rateInputsGrid.toArray();
            if (inputs[currentIndex + 1]) {
                inputs[currentIndex + 1].nativeElement.focus();
            }
        });
    }

    /**
     * Applies a global filter to the table based on the input event.
     * @param event - The input event containing the filter value.
     * @param table - The table instance to apply the filter to.
     */
    filterGlobal(event: Event, table: any) {
        const input = event.target as HTMLInputElement;
        table.filterGlobal(input.value, 'contains');
    }

    /**
     * Enables editing for the rate field of a specific row.
     * @param index - The index of the row to enable editing for.
     */
    enableRateEdit(index: number) {
        this.editingRowIndex = index;
    }

    /**
     * Disables editing for the rate field.
     */
    disableRateEdit() {
        this.editingRowIndex = null;
    }

    /**
     * Handles the enter event for the rate input field.
     * Calculates the amount and focuses on the discount input field.
     */
    // onRateEnter() {

    //     if (this.itemForm.rate < this.minRate || this.itemForm.rate > this.maxRate) {
    //         this.errorMessages.rate = `Rate btwn ${this.minRate}–${this.maxRate}`;

    //         // this.errorMessages.rate = `Rate must be between ${this.minRate} and ${this.maxRate}`;
    //         this.messageService.add({ severity: 'error', summary: 'Invalid Rate', detail: `Rate must be between ${this.minRate} and ${this.maxRate}` });
    //         return;
    //     }
    //     this.errorMessages.rate = '';
    //     this.itemForm.amount = Math.max(0, this.itemForm.quantity * this.itemForm.rate);
    //     this.discountInput.nativeElement.focus();
    // }
    onQuantityEnter() {
        console.log('Entered Quantity:', this.itemForm.quantity);

        const qtyNum = Number(this.itemForm.quantity);
        if (this.isCreditNoteOrder) {
            if (isNaN(qtyNum) || Math.abs(qtyNum) < 0.01) {
                this.errorMessages.quantity = 'Qty Required';
                this.messageService.add({ severity: 'error', summary: 'Invalid Quantity', detail: 'Quantity is required', life: 2000 });
                return;
            }
            this.itemForm.quantity = normalizeCreditNoteQuantity(qtyNum);
            this.errorMessages.quantity = '';
            return;
        }

        if (qtyNum <= 0) {
            this.errorMessages.quantity = 'Qty Required';
            this.messageService.add({ severity: 'error', summary: 'Invalid Quantity', detail: 'Quantity must be greater than 0', life: 2000 });
            return;
        }
        if (this.ruleActiveForDivision) {
            const isStockExcluded = this.isStockCheckExcluded(this.itemForm.itemNumber);
            if (!isStockExcluded && this.itemForm.avlStock <= 0 && this.ar == 1) {
                this.errorMessages.quantity = 'Out of Stock';
                this.messageService.add({ severity: 'error', summary: 'Out of Stock', detail: 'Article is currently out of stock, cannot proceed with Article', life: 5000 });
                return;
            }
            if (!isStockExcluded && this.itemForm.quantity > this.itemForm.avlStock && this.itemForm.avlStock > 0) {
                this.errorMessages.quantity = `Max available stock is ${this.itemForm.avlStock}`;
                this.messageService.add({ severity: 'error', summary: 'Stock Limit Exceeded', detail: `Max available stock is ${this.itemForm.avlStock}` });
            }
        }
    }
    onRateEnter() {
        console.log(this.itemForm.rate);
        console.log(this.minRate);
        //   this.discountInput.nativeElement.focus();
        // Prevent entry if minRate is 0
        // if (this.minRate === 0) {
        //     console.log('Min rate is 0, showing message123');

        //     this.messageService.add({
        //         severity: 'info',
        //         summary: 'Pricelist not available',
        //         detail: 'Price list not available for selected Item'
        //     });
        //     this.errorMessages.rate = '';
        //     this.itemForm.amount = Math.max(0, this.itemForm.quantity * this.itemForm.rate);
        //     console.log(this.itemForm.rate, this.minRate);

        //     console.log('called1');

        //     if (this.division === '400') {
        //         console.log('Division is 400');
        //         console.log("  disc input triggered ",this.discountInput.nativeElement);
        //         this.onDiscountEnter();
        //         if (this.isManagerOrSuperUser) {
        //             console.log(this.discountInput.nativeElement, '<-- Manager or SuperUser');
        //             this.discountInput.nativeElement.focus();
        //         } else {
        //             console.log(this.submitBtnRef.nativeElement, '<-- Not Manager or SuperUser');
        //             this.focusSubmitBtn();
        //         }
        //         console.log(this.discountInput.nativeElement);

        //         this.discountInput.nativeElement.focus();
        //     } else {
        //         this.discountInput.nativeElement.focus();
        //     }
        //     return;
        // }
        if (this.minRate === 0) {
            this.messageService.add({
                severity: 'info',
                summary: 'Pricelist not available',
                detail: 'Price list not available for selected Article',
                life: 1000
            });
        }
        if (!this.isManagerOrSuperUser) {
            if (this.itemForm.rate < this.minRate) {
                this.errorMessages.rate = `Rate must be at least ${Number(this.minRate).toFixed(2)}`;
                this.messageService.add({
                    severity: 'error',
                    summary: 'Invalid Rate',
                    detail: `Rate must be at least ${Number(this.minRate).toFixed(2)}`,
                    life: 2000
                });
                return;
            }
        }

        this.errorMessages.rate = '';
        // this.itemForm.amount = Number(Number(Math.max(0, this.itemForm.quantity * this.itemForm.rate)).toFixed(2));
        Object.assign(this.itemForm, calculateRowAmounts(this.itemForm));
        // vat editable
        // if (this.division === '400') {
        //     this.onDiscountEnter();
        //     if (this.isManagerOrSuperUser) {
        //         console.log(this.discountInput.nativeElement, '<-- Manager or SuperUser');
        //         this.discountInput.nativeElement.focus();
        //     } else {
        //         console.log(this.submitBtnRef.nativeElement, '<-- Not Manager or SuperUser');
        //         this.focusSubmitBtn();
        //     }
        //     console.log(this.discountInput.nativeElement);

        //     // this.discountInput.nativeElement.focus();
        // } else {
        //     this.discountInput.nativeElement.focus();
        // }
        if (this.division === '400') {
            this.onDiscountEnter();
            this.focusSubmitBtn();

            // console.log(this.discountInput.nativeElement);
        } else {
            this.discountInput?.nativeElement?.focus();
        }
    }
    /**
     * Handles the enter event for the VAT input field.
     * Calculates the VAT amount and updates the total amount after VAT.
     */
    onVatEnter() {
        console.log(this.itemForm.vat);
        const { vatAmount, amountAfterVat } = calculateVatFields(this.itemForm.amountAfterDiscount, this.itemForm.vat);
        this.itemForm.vatAmount = vatAmount;
        this.itemForm.amountAfterVat = amountAfterVat;
        console.log('VAT Amount:', vatAmount);
        console.log('Amount after VAT:', amountAfterVat);
    }

    /**
     * Navigates to the picking list page with the current item list.
     * Division 300: no credit/margin restriction — picklist accessible to everyone.
     * Division 100: no credit restriction on picklist (Save / Sync / Invoice still gated).
     */
    openPickingList() {
        if (this.isDivision300()) {
            this.navigateToPickingListInternal();
            return;
        }
        const divisionId = this.division || this.userService.getDivisionId?.() || '';
        if (
            !shouldSkipCreditLimitOnPicklist(divisionId) &&
            this.handleCreditLimitAction('Continue to Picking List', () => this.navigateToPickingListInternal(), 'picklist')
        ) {
            return;
        }
        this.ensureMarginDataThen(() => {
            if (this.handleMarginApprovalAction('Continue to Picking List', () => this.navigateToPickingListInternal(true), 'picklist')) {
                return;
            }
            this.navigateToPickingListInternal();
        });
    }

    private navigateToPickingListInternal(marginApprovalAcknowledged = false): void {
        console.log('Navigating to picking list with items:', this.itemList);
        console.log(this.item);

        this.router.navigate(['/picking-list'], {
            state: { item: this.item, itemList: this.itemList, creditLimitAcknowledged: true, marginApprovalAcknowledged }
        });
    }

    /**
     * Handles the blur event for the rate input field of a row.
     * Recalculates the amounts and updates the status of the row.
     * @param row - The row to update.
     */
    onRateBlur(row: any) {
        // ⭐ Preserve originalQuantity when status changes from 20 to 30
        if (row.status === 20 && row.originalQuantity === undefined) {
            row.originalQuantity = row.quantity;
        }
        console.log('onRateBlur called', row);

        Object.assign(row, calculateRowAmounts(row));
        row.status = 30;
        localStorage.setItem('orderLines', JSON.stringify(this.itemList));
    }

    /**
     * Handles the blur event for the discount input field of a row.
     * Recalculates the amounts and updates the status of the row.
     * @param row - The row to update.
     */
    onDiscountBlur(row: any) {
        // ⭐ Preserve originalQuantity when status changes from 20 to 30
        if (row.status === 20 && row.originalQuantity === undefined) {
            row.originalQuantity = row.quantity;
        }

        Object.assign(row, calculateRowAmounts(row));
        row.status = 30;
        localStorage.setItem('orderLines', JSON.stringify(this.itemList));
    }
    /**
     * Handles the enter event for the discount input field.
     * Calculates the discount amount and focuses on the VAT input field.
     */
    onDiscountEnter() {
        console.log(this.itemForm.discount);
        const rawDiscount = Number(this.itemForm.discount);
        this.itemForm.discount = clampDiscountPercent(this.itemForm.discount);
        if (Number.isFinite(rawDiscount) && rawDiscount > 100) {
            this.messageService.add({ severity: 'warn', summary: 'Discount', detail: 'Discount cannot exceed 100.', life: 3000 });
        }
        const { discountAmount, amountAfterDiscount } = calculateDiscountFields(this.itemForm.amount, this.itemForm.discount);
        console.log('Discount Amount:', discountAmount);
        console.log('Amount after Discount:', this.itemForm.discount);

        this.itemForm.amountAfterDiscount = amountAfterDiscount;
        console.log('Amount after Discount:', this.itemForm.amountAfterDiscount);

        // Optionally, recalculate VAT as well
        const { vatAmount, amountAfterVat } = calculateVatFields(this.itemForm.amountAfterDiscount, this.itemForm.vat);
        this.itemForm.vatAmount = vatAmount;
        this.itemForm.amountAfterVat = amountAfterVat;
        console.log('VAT Amount:', vatAmount);
        console.log('Amount after VAT:', amountAfterVat);
        // if (this.isManagerOrSuperUser) {
        //     this.vatInput.nativeElement.focus();
        // } else {
        this.focusSubmitBtn();
        // }
    }
    /**
     * Handles the enter event for both discount and VAT input fields.
     */
    onDiscountAndVatEnter() {
        this.onDiscountEnter();
        this.onVatEnter();
    }

    /**
     * Handles the blur event for the VAT input field of a row.
     * Recalculates the VAT amount and updates the total amount after VAT.
     * @param row - The row to update.
     */
    onVatBlur(row: any) {
        Object.assign(row, calculateRowAmounts(row));
        // Optionally update status or storage if needed
    }

    /**
     * Handles the blur event for the quantity input field of a row.
     * Recalculates the amount based on the updated quantity.
     * @param row - The row to update.
     */
    onQuantityBlur(row: any) {
        if (row.status === 20 && row.originalQuantity === undefined) {
            row.originalQuantity = row.quantity;
        }
    
        // ✅ ADD THIS: Recalculate all amounts when quantity changes
        Object.assign(row, calculateRowAmounts(row));
        row.status = 30;
        localStorage.setItem('orderLines', JSON.stringify(this.itemList));
    }

    /**
     * Focuses on the next quantity input field in the grid.
     * @param rowIndex - The index of the current quantity input field.
     */
    focusNextQuantityInputGrid(rowIndex: number) {
        setTimeout(() => {
            const inputs = this.quantityInputsGrid.toArray();
            if (inputs[rowIndex + 1]) {
                inputs[rowIndex + 1].nativeElement.focus();
            }
        });
    }

    showAddItemForm = true;

    /**
     * Toggles the visibility of the add item form.
     */
    toggleAddItemForm() {
        this.showAddItemForm = !this.showAddItemForm;
    }

    headerPanelOpen = true;

    /**
     * Toggles the visibility of the header panel.
     */
    toggleHeaderPanel() {
        this.headerPanelOpen = !this.headerPanelOpen;
    }

    /**
     * Simulates exporting the invoice to mail and displays a success message.
     */
    exportToMail() {
        // Simulate sending invoice to mail
        this.messageService.add({
            severity: 'success',
            summary: 'Export to Mail',
            detail: 'Invoice would be sent to mail (simulation only).',
            life: 2000
        });
    }
    /**
     * Focuses on the rate input field in the grid.
     * @param rowIndex - The index of the rate input field to focus on.
     */
    focusRateInputGrid(rowIndex: number) {
        setTimeout(() => {
            const inputs = this.rateInputsGrid.toArray();
            if (inputs[rowIndex]) {
                inputs[rowIndex].nativeElement.focus();
            }
        });
    }

    /**
     * Focuses on the amount input field in the grid.
     * @param rowIndex - The index of the amount input field to focus on.
     */
    focusAmountInputGrid(rowIndex: number) {
        setTimeout(() => {
            const inputs = this.amountInputsGrid.toArray();
            if (inputs[rowIndex]) {
                inputs[rowIndex].nativeElement.focus();
            }
        });
    }

    /**
     * Focuses on the discount input field in the grid.
     * @param rowIndex - The index of the discount input field to focus on.
     */
    focusDiscountInputGrid(rowIndex: number) {
        setTimeout(() => {
            const inputs = this.discountInputs.toArray();
            if (inputs[rowIndex]) {
                inputs[rowIndex].nativeElement.focus();
            }
        });
    }

    /**
     * Calculates the total value of all items in the list.
     * @returns The total value.
     */
    getTotalValue(): number {
        return (this.itemList || []).reduce((sum, row) => sum + (Number(row.amount) || 0), 0);
    }

    /**
     * Calculates the total discount value in currency.
     * @returns The total discount value.
     */
    getTotalDiscountValue(): number {
        // Discount value in currency, not percent
        return (this.itemList || []).reduce((sum, row) => {
            const amt = Number(row.amount) || 0;
            const disc = Number(row.discount) || 0;
            return sum + (amt * disc) / 100;
        }, 0);
    }

    /**
     * Calculates the total subscription value (total after VAT).
     * @returns The total subscription value.
     */
    getSubscription(): number {
        return round2(this.getTotalNetAmount() + this.getTotalVatAmount());
    }
    /**
     * Calculates the total net amount of all items in the list.
     * @returns The total net amount.
     */
    getTotalNetAmount(): number {
        const sum = (this.itemList || []).reduce((s, row) => s + (Number(row.amountAfterDiscount) || 0), 0);
        return round2(sum);
    }

    /**
     * Calculates the total VAT amount of all items in the list.
     * @returns The total VAT amount.
     */
    getTotalVatAmount(): number {
        const netByRate = new Map<number, number>();
        for (const row of this.itemList || []) {
            const rate = Number(row.vat) ?? 0;
            const net = Number(row.amountAfterDiscount) ?? 0;
            netByRate.set(rate, (netByRate.get(rate) ?? 0) + net);
        }
        let vatTotal = 0;
        netByRate.forEach((netSum, rate) => {
            vatTotal += round2((netSum * rate) / 100);
        });
        return round2(vatTotal);
    }

    /**
     * Calculates the total weight of all items in the list.
     * @returns The total weight (sum of netWeight * quantity for each item).
     */
    getTotalWeight(): number {
        const sum = (this.itemList || []).reduce((s, row) => {
            const netWeight = Number(row.netWeight) || 0;
            const quantity = Number(row.quantity) || 0;
            return s + (netWeight * quantity);
        }, 0);
        return round2(sum);
    }

    onVatChange() {
        const { vatAmount, amountAfterVat } = calculateVatFields(this.itemForm.amountAfterDiscount, this.itemForm.vat);
        this.itemForm.vatAmount = vatAmount;
        this.itemForm.amountAfterVat = amountAfterVat;
    }

    /**
     * Focuses on the submit button.
     */
    focusSubmitBtn() {
        setTimeout(() => {
            if (this.submitBtnRef) {
                this.submitBtnRef.nativeElement.focus();
            }
        });
    }

    // Focuses on the quantity input field when item number or item name is selected.
    // focusQuantityInput() {
    //     setTimeout(() => {
    //         if (this.quantityInput) {
    //             this.quantityInput.nativeElement.focus();
    //         }
    //     });
    // }

    /**
     * Resets additional fields such as warehouses and price lists.
     */
    resetAdditionalFields() {
        this.warehouses = this.defaultWarehouses.map((wh) => ({ ...wh, qty: 0 })); // Reset warehouse quantities
        this.setPriceListsByPltb(this.product?.pltb ?? this.item?.pltb);
        this.priceLists = this.priceLists.map((pl) => ({ ...pl, value: 0 }));
        this.info = {}; // Reset info section
        this.lastFetchedItemDetailsContextKey = null;
    }

    /** Sidebar-only state when a grid line is selected (inspect mode; does not touch itemForm). */
    protected lineInfoView: { itemNumber: string; itemName: string; avlStock: number } | null = null;

    protected get isViewOnlyOrderLines(): boolean {
        return this.readOnly || this.isReadOnly;
    }

    private filterPriceListsForDivision(lists: { name: string; value: number }[]): { name: string; value: number }[] {
        const src = lists || [];
        const fam = this.inferPriceListFamily(
            this.product?.pltb ?? this.item?.pltb,
            this.product?.defaultPriceList ?? this.item?.defaultPriceList,
            src
        );
        if (fam === 'NL') {
            return src.filter((pl) => pl.name.startsWith('NL'));
        }
        if (fam === 'PL') {
            return src.filter((pl) => pl.name.startsWith('PL'));
        }
        if (fam === 'FR') {
            return src.filter((pl) => pl.name.startsWith('FR'));
        }
        return [];
    }

    protected calculateAdjustedAvlStockForItem(itemNumber: string, apiStock: number): number {
        if (this.isStockCheckExcluded(itemNumber)) {
            return Math.max(0, Number(apiStock) || 0);
        }

        const avlqty = Number(apiStock) || 0;
        const existingItems = this.itemList.filter((item) => item.itemNumber === itemNumber);
        const deletedItemsForThisItem = this.deletedItems.get(itemNumber) || [];

        let totalToSubtract = 0;

        if (this.itemForm.itemNumber === itemNumber) {
            const currentItemQty = Number(this.itemForm.quantity) || 0;
            if (currentItemQty > 0) {
                totalToSubtract += currentItemQty;
            }
        }

        existingItems.forEach((item) => {
            if (item.status === 10) {
                totalToSubtract += Number(item.quantity) || 0;
            } else if (item.status === 30) {
                const originalQty = item.originalQuantity !== undefined ? Number(item.originalQuantity) : Number(item.quantity);
                const currentQty = Number(item.quantity) || 0;
                const originalStatus = item.originalStatus;

                if (originalStatus === 10) {
                    totalToSubtract += currentQty;
                } else if (originalStatus === 20) {
                    totalToSubtract += currentQty - originalQty;
                } else {
                    const wasSaved = item.originalQuantityWasSaved === true;
                    if (!wasSaved) {
                        totalToSubtract += currentQty;
                    } else {
                        totalToSubtract += currentQty - originalQty;
                    }
                }
            }
        });

        let totalToAddBack = 0;

        deletedItemsForThisItem.forEach((deletedItem) => {
            if (deletedItem.status === 20) {
                totalToAddBack += deletedItem.quantity;
            } else if (deletedItem.status === 30 && deletedItem.originalQuantityWasSaved === true) {
                const originalQty = deletedItem.originalQuantity !== undefined ? deletedItem.originalQuantity : deletedItem.quantity;
                totalToAddBack += originalQty;
            }
        });

        return Math.max(0, avlqty + totalToAddBack - totalToSubtract);
    }

    protected currentItemDetailsContextKey(itemNumber?: string): string {
        const itno = String(itemNumber ?? this.itemForm?.itemNumber ?? '').trim();
        const cuno = String(this.item?.customerId || this.item?.customer || '').trim();
        const whlo = String(this.item?.warehouseId || this.item?.whsId || this.item?.warehouse || this.item?.whlo || '').trim();
        return [this.company, this.division, itno, cuno, whlo].join('|');
    }

    /** Load sidebar item info for an existing order line. */
    loadItemInfoForOrderLine(row: { itemNumber?: string; itemName?: string }, options?: { inspectOnly?: boolean }) {
        const itemNumber = String(row?.itemNumber ?? '').trim();
        if (!itemNumber) {
            return;
        }

        const itemName = row?.itemName ?? '';
        const inspectOnly = options?.inspectOnly === true;

        if (inspectOnly) {
            this.lineInfoView = { itemNumber, itemName, avlStock: 0 };
        } else {
            this.itemForm.itemNumber = itemNumber;
            this.itemForm.itemName = itemName;
        }

        this.setPriceListsByPltb(this.product?.pltb ?? this.item?.pltb);
        this.priceLists = this.priceLists.map((pl) => ({ ...pl, value: 0 }));

        const body = {
            itno: itemNumber,
            cuno: this.item?.customerId || this.item?.customer || '',
            whlo: this.item?.warehouseId || this.item?.whsId || this.item?.warehouse || this.item?.whlo || ''
        };
        const itemDetailsContextKey = this.currentItemDetailsContextKey(itemNumber);

        this.itemOrderHandler.getAndProcessItemDetails({
            company: this.company,
            division: this.division,
            defaultPriceList: this.product?.defaultPriceList || this.item?.defaultPriceList || '',
            body,
            priceLists: this.priceLists,
            warehouses: this.warehouses,
            info: this.info,
            traceReason: inspectOnly ? 'INSPECT_LINE' : 'SELECT_ITEM',
            loadingSetter: (val: boolean) => (this.loading = val),
            loaderMessageSetter: (l1: string, l2: string) => {
                this.loaderMessageLine1 = l1;
                this.loaderMessageLine2 = l2;
            },
            qtySetter: (avlqty) => {
                const stock = Number(avlqty) || 0;
                if (inspectOnly) {
                    const displayStock = this.isViewOnlyOrderLines ? stock : this.calculateAdjustedAvlStockForItem(itemNumber, stock);
                    this.lineInfoView = { itemNumber, itemName, avlStock: displayStock };
                    return;
                }
                this.itemForm.apiStock = stock;
                this.itemForm.avlStock = stock;
            },
            priceListsSetter: (lists) => {
                this.priceLists = this.filterPriceListsForDivision(lists);
            },
            warehousesSetter: (warehouses) => {
                this.warehouses = warehouses;
            },
            infoSetter: (info) => {
                this.info = info;
            },
            successHandler: () => {
                this.lastFetchedItemDetailsContextKey = itemDetailsContextKey;
            },
            messageHandler: (msg) => this.messageService.add(msg)
        });
    }

    /**
     * Handles changes to the item number input field.
     * Resets additional fields and fetches item details if the item number is valid.
     */
    onItemNumberChange() {
        console.log('onItemNumberChange called with itemNumber:', this.itemForm.itemNumber);

        // this.resetAdditionalFields();
        if (!this.itemForm.itemNumber) {
            console.warn('Item Number is empty. Resetting item info values.');
            this.lastFetchedItemDetailsContextKey = null;

            // Reset item info values
            this.itemForm.quantity = 0;
            this.itemForm.rate = 0;
            this.itemForm.amount = 0;
            this.itemForm.discount = 0;
            this.itemForm.amountAfterDiscount = 0;
            this.itemForm.vat = this.info.vatPercentage1 ?? 0;
            this.itemForm.amountAfterVat = 0;

            return;
        }
        console.log(this.product?.defaultPriceList);

        const defaultPL = this.product?.defaultPriceList;
        if (defaultPL) {
            console.log(this.priceLists);

            // const found = this.priceLists.find((pl) => pl.name.toUpperCase() === defaultPL.toUpperCase());
            // console.log('Searching for default price list:', defaultPL, 'Found:', found);

            // console.log('Found default price list:', found);

            // if (found) {
            //     console.log('Setting default price list rate:', found.value);

            //     this.itemForm.rate = Number(found.value); // Convert to number if needed
            // }
        }
        console.log(this.itemForm.rate);

        const duplicateItem = this.itemList.find((item) => {
            console.log('Checking for duplicate item:', item.itemNumber, 'Current item number:', this.itemForm.itemNumber);
            return item.itemNumber === this.itemForm.itemNumber;
        });
        if (duplicateItem) {
            this.validationError = true;
            console.warn('Duplicate article found:', duplicateItem.itemNumber);
            this.messageService.add({ severity: 'error', summary: 'Duplicate Article', detail: 'This article number already exists in the table.', life: 3000 });
        } else {
            this.validationError = false;
        }
        console.log(this.item);

        const body = {
            itno: this.itemForm.itemNumber,
            // Use normalized customer id to avoid passing null/label text as OBCUNO.
            cuno: this.item.customerId || this.item.customer || '',

            whlo: this.item.warehouseId || this.item.whsId || this.item.warehouse || this.item.whlo || ''
        };
        const itemDetailsContextKey = this.currentItemDetailsContextKey(this.itemForm.itemNumber);
        this.itemOrderHandler.getAndProcessItemDetails({
            company: this.company,
            division: this.division,
            defaultPriceList: this.product?.defaultPriceList || this.item?.defaultPriceList || '',
            body,
            priceLists: this.priceLists,
            warehouses: this.warehouses,
            info: this.info,
            traceReason: 'SELECT_ITEM',
            loadingSetter: (val: boolean) => (this.loading = val),
            loaderMessageSetter: (l1: string, l2: string) => {
                this.loaderMessageLine1 = l1;
                this.loaderMessageLine2 = l2;
            },
            // Around line 1925 - Replace qtySetter
            qtySetter: (avlqty) => {
                if (this.isStockCheckExcluded(this.itemForm.itemNumber)) {
                    const stock = Math.max(0, Number(avlqty) || 0);
                    this.itemForm.avlStock = stock;
                    this.itemForm.apiStock = stock;
                    return;
                }
                this.itemForm.apiStock = avlqty;
                this.itemForm.avlStock = this.calculateAdjustedAvlStockForItem(this.itemForm.itemNumber, avlqty);
            },

            priceListsSetter: (lists) => {
                const src = lists || [];
                const fam = this.inferPriceListFamily(
                    this.product?.pltb ?? this.item?.pltb,
                    this.product?.defaultPriceList ?? this.item?.defaultPriceList,
                    src
                );
                if (fam === 'NL') {
                    this.priceLists = src.filter((pl) => pl.name.startsWith('NL'));
                } else if (fam === 'PL') {
                    this.priceLists = src.filter((pl) => pl.name.startsWith('PL'));
                } else if (fam === 'FR') {
                    this.priceLists = src.filter((pl) => pl.name.startsWith('FR'));
                } else {
                    this.priceLists = [];
                }
            },

            // Around line 1992 - Replace warehousesSetter
            warehousesSetter: (warehouses) => {
                console.log('=== warehousesSetter START ===');
                console.log('Warehouses from API:', JSON.parse(JSON.stringify(warehouses)));
                console.log('Current itemForm.itemNumber:', this.itemForm.itemNumber);

                // Check if this item already exists in the order
                const existingItems = this.itemList.filter((item) => item.itemNumber === this.itemForm.itemNumber);
                console.log('Existing items with same itemNumber:', JSON.parse(JSON.stringify(existingItems)));

                // ⭐ Get deleted items for this itemNumber
                const deletedItemsForThisItem = this.deletedItems.get(this.itemForm.itemNumber) || [];
                console.log('Deleted items for this itemNumber:', JSON.parse(JSON.stringify(deletedItemsForThisItem)));

                // Calculate total quantity to subtract based on status
                let totalToSubtract = 0;

                existingItems.forEach((item, index) => {
                    console.log(`--- Processing existing item ${index + 1} for warehouse calculation ---`);
                    console.log('Item status:', item.status);
                    console.log('Item quantity:', item.quantity);
                    console.log('Item originalQuantity:', item.originalQuantity);

                    if (item.status === 10) {
                        const qty = Number(item.quantity) || 0;
                        totalToSubtract += qty;
                        console.log(`✅ Status 10: Adding ${qty} to subtract`);
                    } else if (item.status === 30) {
                        const originalQty = item.originalQuantity !== undefined ? Number(item.originalQuantity) : Number(item.quantity);
                        const currentQty = Number(item.quantity) || 0;

                        console.log('Item originalStatus:', item.originalStatus);
                        console.log('Item originalQuantityWasSaved:', item.originalQuantityWasSaved);

                        // ⭐ CRITICAL: Use originalStatus to determine calculation (same logic as qtySetter)
                        const originalStatus = item.originalStatus;

                        if (originalStatus === 10) {
                            // Item was status 10 (unsaved) before editing → subtract FULL current quantity
                            totalToSubtract += currentQty;
                            console.log(`✅ Status 30 (originalStatus=10, was UNSAVED): subtracting FULL ${currentQty} (total now: ${totalToSubtract})`);
                        } else if (originalStatus === 20) {
                            // Item was status 20 (saved) before editing → subtract only the difference
                            const difference = currentQty - originalQty;
                            totalToSubtract += difference;
                            console.log(`✅ Status 30 (originalStatus=20, was SAVED): originalQty=${originalQty}, currentQty=${currentQty}, difference=${difference} (total now: ${totalToSubtract})`);
                        } else {
                            // Fallback: use originalQuantityWasSaved flag if originalStatus is not set
                            const wasSaved = item.originalQuantityWasSaved === true;
                            if (!wasSaved) {
                                totalToSubtract += currentQty;
                                console.log(`⚠️ Status 30 (originalStatus undefined, fallback to flag=false): subtracting FULL ${currentQty} (total now: ${totalToSubtract})`);
                            } else {
                                const difference = currentQty - originalQty;
                                totalToSubtract += difference;
                                console.log(`⚠️ Status 30 (originalStatus undefined, fallback to flag=true): difference=${difference} (total now: ${totalToSubtract})`);
                            }
                        }
                    } else if (item.status === 20) {
                        console.log(`⏭️ Status 20: Skipping (already deducted in API)`);
                    }
                });

                // ⭐ Calculate total quantity to ADD BACK from deleted saved items
                let totalToAddBack = 0;

                deletedItemsForThisItem.forEach((deletedItem, index) => {
                    console.log(`--- Processing deleted item ${index + 1} for warehouse calculation ---`);
                    console.log('Deleted item status:', deletedItem.status);
                    console.log('Deleted item quantity:', deletedItem.quantity);
                    console.log('Deleted item originalQuantity:', deletedItem.originalQuantity);
                    console.log('Deleted item originalQuantityWasSaved:', deletedItem.originalQuantityWasSaved);

                    if (deletedItem.status === 20) {
                        totalToAddBack += deletedItem.quantity;
                        console.log(`✅ Deleted Status 20: Adding back ${deletedItem.quantity}`);
                    } else if (deletedItem.status === 30 && deletedItem.originalQuantityWasSaved === true) {
                        // ⭐ Only add back if originalQuantity was from saved item
                        // Check originalStatus if available, otherwise fallback to originalQuantityWasSaved
                        const shouldAddBack = deletedItem.originalStatus === 20 || (deletedItem.originalStatus === undefined && deletedItem.originalQuantityWasSaved === true);

                        if (shouldAddBack) {
                            const originalQty = deletedItem.originalQuantity !== undefined ? deletedItem.originalQuantity : deletedItem.quantity;
                            totalToAddBack += originalQty;
                            console.log(`✅ Deleted Status 30 (from saved): Adding back originalQuantity ${originalQty}`);
                        } else {
                            console.log(`⏭️ Deleted Status 30 was never saved, not adding back`);
                        }
                    }
                });

                // Adjust warehouse quantities
                warehouses = warehouses.map((warehouse) => {
                    if (warehouse.qty !== undefined && warehouse.qty !== null) {
                        const adjustedQty = Math.max(0, Number(warehouse.qty) + totalToAddBack - totalToSubtract);
                        console.log(`Warehouse ${warehouse.name}: API=${warehouse.qty}, AddBack=${totalToAddBack}, Subtract=${totalToSubtract}, Adjusted=${adjustedQty}`);
                        return { ...warehouse, qty: adjustedQty };
                    }
                    return warehouse;
                });

                console.log('=== warehousesSetter END ===');

                this.warehouses = warehouses;
            },
            infoSetter: (info) => {
                setTimeout(() => {
                    // ✅ Apply rule only if OUT_OF_STOCK_QTY is active for this division
                    if (this.itemForm.avlStock <= 0 && this.ruleActiveForDivision && this.ar == 1 && !this.isStockCheckExcluded(this.itemForm.itemNumber)) {
                        console.log('Stock is 0 and rule active, showing out of stock message');
                        this.errorMessages.quantity = 'Out of Stock';
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Out of Stock',
                            detail: 'Article is currently out of stock, cannot proceed with Article',
                            life: 5000
                        });
                    } else {
                        console.log('Either stock > 0 or rule inactive — proceeding normally');
                    }
                }, 100);

                // const found = this.priceLists.find((pl) => pl.name.toUpperCase() === defaultPL.toUpperCase());
                const found = defaultPL ? this.priceLists.find((pl) => pl.name && pl.name.toUpperCase() === defaultPL.toUpperCase()) : undefined;

                console.log('Searching for default price list:', defaultPL, 'Found:', found);

                console.log('Found default price list:', found);

                if (found) {
                    console.log('Setting default price list rate:', found.value);

                    this.itemForm.rate = Number(Number(found.value).toFixed(2));
                }

                this.info = info;
                // Set VAT and other fields in itemForm from info if available
                console.log('Setting VAT from info:', info);

                if (info) {
                    console.log('Setting item form fields from info:  Vat', info.vatPercentage1);
                    console.log('Should fetch VAT percentage:', this.product.shouldFetchVatPercentage);
                    console.log('Current itemForm.vat before assignment:', this.item.shouldFetchVatPercentage);
                    this.ar = info.AR;
                    this.itemForm.ar = this.ar; // Add this line
                    if (this.product.shouldFetchVatPercentage) {
                        if (info.vatPercentage1 !== undefined && info.vatPercentage1 !== null && info.vatPercentage1 !== '') {
                            this.itemForm.vat = Number(info.vatPercentage1);
                            console.log('Assigned VAT to itemForm.vat:', this.itemForm.vat);
                        }
                    }
                    if (info.vatCode !== undefined && info.vatCode !== null) {
                        this.itemForm.vatCode = info.vatCode;
                    }
                    if (info.grossWeight !== undefined && info.grossWeight !== null) {
                        this.itemForm.grossWeight = Number(info.grossWeight);
                    }
                    if (info.netWeight !== undefined && info.netWeight !== null) {
                        this.itemForm.netWeight = Number(info.netWeight);
                    }
                    if (info.pcs !== undefined && info.pcs !== null) {
                        this.itemForm.pcs = Number(info.pcs);
                    }
                    if (info.size !== undefined && info.size !== null) {
                        this.itemForm.size = info.size;
                    }
                    if (info.itemGroup !== undefined && info.itemGroup !== null) {
                        this.itemForm.itemGroup = info.itemGroup;
                    }
                    this.itemForm.noDecPl = resolveQtyDecimalPlaces(extractNoDecPl(info), 2);
                }
            },
            successHandler: () => {
                this.lastFetchedItemDetailsContextKey = itemDetailsContextKey;
            },
            messageHandler: (msg) => this.messageService.add(msg)
        });
    }
    private isStockCheckExcluded(itemNumber: unknown): boolean {
        return this.stockCheckExcludedItemNumbers.has(String(itemNumber ?? '').trim());
    }
    /**
     * Filters item names based on the input query.
     * @param event - The autocomplete event containing the query.
     */
    filterItemNames(event: AutoCompleteCompleteEvent) {
        const query = event.query.trim();
        if (query.length < 3) {
            this.filteredItemNames = [];
            return;
        }
        console.log('Filtering item names with query:', query);
        // Always append * to the query for backend wildcard search
        console.log('Warehouse ID:', this.warehouse);

        this.itemDetailsService
            .searchItemNames(query + '*', this.company, this.division, this.warehouse)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (resp) => {
                    console.log('Item numbers search response:', resp);

                    const excludedGroups = ['199001', '114003', '114002'];

                    if (Array.isArray(resp) && resp.length > 0) {
                        // ✅ Check if at least one item has MMITGR field
                        const hasMMITGR = resp.some((item) => 'MMITGR' in item && item.MMITGR !== undefined && item.MMITGR !== null);

                        this.filteredItemNames = hasMMITGR ? resp.filter((item) => !excludedGroups.includes(item.MMITGR)) : resp; // take all if MMITGR not present
                    } else {
                        this.filteredItemNames = [];
                    }
                },
                error: () => {
                    this.filteredItemNames = [];
                }
            });
    }
    filterItemNumber(event: AutoCompleteCompleteEvent) {
        const query = event.query.trim();
        if (query.length < 3) {
            this.filteredItemNumbers = [];
            return;
        }
        console.log('Filtering item numbers with query:', query);
        console.log('Warehouse ID:', this.warehouse);

        // Always append * to the query for backend wildcard search
        this.itemDetailsService
            .searchItemNumbers(query + '*', this.company, this.division, this.warehouse)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (resp) => {
                    console.log('Item numbers search response:', resp);

                    const excludedGroups = ['199001', '114003', '114002'];

                    if (Array.isArray(resp) && resp.length > 0) {
                        // ✅ Check if at least one item has MMITGR field
                        const hasMMITGR = resp.some((item) => 'MMITGR' in item && item.MMITGR !== undefined && item.MMITGR !== null);

                        this.filteredItemNumbers = hasMMITGR ? resp.filter((item) => !excludedGroups.includes(item.MMITGR)) : resp; // take all if MMITGR not present
                    } else {
                        this.filteredItemNumbers = [];
                    }
                },
                error: () => {
                    this.filteredItemNumbers = [];
                }
            });
    }
    /**
     * Handles the selection of an item name from the autocomplete dropdown.
     * Updates the item form with the selected item's details.
     * @param event - The event containing the selected item.
     */
    onItemNameSelect(event: any) {
        this.itemSelected = true;
        // For PrimeNG p-autoComplete, the selected item is in event (or event.value or event.originalEvent.value depending on version)
        const selected = event && event.value ? event.value : event;
        console.log('Selected item:', selected);

        if (selected && selected.MBITNO) {
            console.log('Selected item number:', selected.MBITNO);
            this.itemForm.itemNumber = selected.MBITNO;
            this.suppressItemInputReset = true;
            setTimeout(() => (this.suppressItemInputReset = false));
            this.onItemNumberChange();
        }
        if (selected && selected.MMFUDS) {
            console.log('Selected item name:', selected.MMFUDS);

            this.itemForm.itemName = selected.MMFUDS;
            this.itemForm.FINALRESPNSE = selected.FINALRESPNSE;

            console.log('Selected item name:', this.itemForm.itemName);
        }
    }
    itemSelected = false;
    private suppressItemInputReset = false;

    onItemNumberSelect(event: any) {
        console.log('onItemNumberSelect called with event:', event);
        this.itemSelected = true;
        // For PrimeNG p-autoComplete, the selected item is in event (or event.value or event.originalEvent.value depending on version)
        const selected = event && event.value ? event.value : event;
        console.log('Selected item:', selected);

        if (selected && selected.MMFUDS) {
            console.log('Selected item number:', selected.MBITNO);
            this.itemForm.itemNumber = selected.MBITNO;

            this.suppressItemInputReset = true;
            setTimeout(() => (this.suppressItemInputReset = false));
            this.onItemNumberChange();
            this.itemForm.itemName = selected.MMFUDS;
            this.itemForm.FINALRESPNSE = selected.FINALRESPNSE;
        }
        if (selected && selected.MBITNO) {
            this.itemForm.itemNumber = selected.MBITNO;
        }
        console.log(this.itemForm.avlStock, '<-- Aval stock');
    }

    onItemNumberInputChange(event: any) {
        if (this.suppressItemInputReset) {
            return;
        }
        this.resetAdditionalFields();
        // Optionally clear errors if any
        this.errorMessages.itemno = '';
        this.errorMessages.itemName = '';
        this.errorMessages.quantity = '';
        this.errorMessages.rate = '';
        this.errorMessages.discount = '';

        if (this.itemSelected) {
            this.itemForm.FINALRESPNSE = '';
            this.itemForm.itemNumber = '';
            this.itemForm.itemName = '';
            this.itemForm.quantity = 0;
            this.itemForm.rate = 0;
            this.itemForm.amount = 0;
            this.itemForm.discount = 0;
            this.itemForm.amountAfterDiscount = 0;
            this.itemForm.vat = 0;
            this.itemForm.amountAfterVat = 0;
            this.itemForm.vatAmount = 0;
            this.itemSelected = false;
        }
    }

    onItemNameInputChange(event: any) {
        if (this.suppressItemInputReset) {
            return;
        }
        this.resetAdditionalFields();
        // Optionally clear errors if any
        this.errorMessages.itemno = '';
        this.errorMessages.itemName = '';
        this.errorMessages.quantity = '';
        this.errorMessages.rate = '';
        this.errorMessages.discount = '';

        if (this.itemSelected) {
            this.itemForm.FINALRESPNSE = '';
            this.itemForm.itemNumber = '';
            this.itemForm.itemName = '';
            this.itemForm.quantity = 0;
            this.itemForm.rate = 0;
            this.itemForm.amount = 0;
            this.itemForm.discount = 0;
            this.itemForm.amountAfterDiscount = 0;
            this.itemForm.vat = 0;
            this.itemForm.amountAfterVat = 0;
            this.itemForm.vatAmount = 0;

            this.itemSelected = false;
        }
    }
    /**
     * Updates the customer name in the component state.
     * @param newName - The new customer name.
     */
    updateCustomerName(newName: string) {
        this.customerName = newName;
    }

    restrictDecimals(event: any, field: 'quantity' | 'rate' | 'discount'): void {
        let value = event.target.value;
        const maxDecimals = field === 'quantity'
            ? resolveQtyDecimalPlaces(this.itemForm.noDecPl ?? extractNoDecPl(this.info), 2)
            : 2;
        const restricted = restrictDecimalInputValue(String(value ?? ''), maxDecimals);
        if (restricted !== value) {
            event.target.value = restricted;
            value = restricted;
        }
        this.itemForm[field] = parseLocaleDecimal(restricted);
    }

    /**
     * Submits the order header and lines to the server.
     * Displays success or error messages based on the API response.
     */
    submitOrder() {
        if (this.loading || this.orderSaveInFlight) {
            return;
        }

        apiTraceFlow('SAVE_ORDER', {
            lines: (this.itemList || []).length,
            company: this.company,
            division: this.division,
            draft: this.isImmediateDivision ? 1 : 0
        });

        const isDraftSave = this.isImmediateDivision;
        if (isDraftSave && this.shouldShowWh101OrderTypeWarning()) {
            this.wh101OrderTypeWarningVisible = true;
            return;
        }

        const minBusinessQty = 0.01;
        const minBusinessRate = 0.01;

        // Stock gate applies to Save as Draft AND Save Order (Excel/copy/grid). Credit notes exempt.
        if (this.blockSaveIfStockErrors()) {
            return;
        }

        const invalidLines = (this.itemList || []).filter((line: any) => {
            if (!line || !line.itemNumber) {
                return false;
            }
            const qty = Number(line.quantity ?? 0);
            const rate = Number(line.rate ?? 0);
            if (this.isCreditNoteOrder) {
                return Math.abs(qty) <= minBusinessQty || rate <= minBusinessRate;
            }
            return qty <= minBusinessQty || rate <= minBusinessRate;
        });

        if (!isDraftSave && invalidLines.length) {
            this.messageService.add({
                severity: 'error',
                summary: 'Cannot save',
                detail: this.isCreditNoteOrder
                    ? 'Quantity (absolute value) and rate must be greater than 0.01 for all lines before saving.'
                    : 'Quantity and rate must be greater than 0.01 for all lines before saving.',
                life: 4000
            });
            return;
        }

        // Ensure phoneNumber and customerAddress are mapped from item correctly
        if (!this.item.phoneNumber && this.item.combinedAddress) {
            // If phoneNumber is missing, try to get from product or fallback
            this.item.phoneNumber = this.item.phoneNumber || '';
            this.item.mail = this.item.mail || '';
            console.log('ITEM MAIL ', this.item.mail);
        }
        const isCustomOrder =
            this.item?.isCustom === 1 ||
            this.item?.isCustom === '1' ||
            this.product?.isCustom === 1 ||
            this.product?.isCustom === '1';
        if (!isCustomOrder && !this.item.customerAddress) {
            // Map customerAddress from combinedAddress if not already present
            this.item.customerAddress = this.item.combinedAddress || '';
        }
        // const orderNumber = this.item?.orderNumber || '';
        // const companyId = this.company;
        // const divisionId = this.division;
        // const currentUsername = this.salesPerson;

        // this.itemOrderHandler.releaseOrderLock(orderNumber, companyId, divisionId, currentUsername).subscribe({
        //     next: (res: any) => {
        //         this.messageService.add({ severity: 'success', summary: 'Lock Released', detail: res?.message || 'Order lock released.' });
        //     },
        //     error: (err) => {
        //         let msg = typeof err.error === 'string' ? err.error : err.error?.message || 'Could not release lock.';
        //         this.messageService.add({ severity: 'error', summary: 'Release Failed', detail: msg });
        //     }
        // });
        const restriction = this.getCreditRestrictionState();
        if (
            this.isCreditLimitCheckEnabledForDivision &&
            !this.shouldSkipCreditLimitCheckForOrder() &&
            isCreditRestrictionActive(restriction)
        ) {
            this.configureCreditLimitDialog(restriction);
            this.creditLimitDialogVisible = true;
            return;
        }

        this.submitOrderAfterValidations();
    }

    protected shouldShowWh101OrderTypeWarning(): boolean {
        const wh = String(this.item?.whsId || this.item?.warehouseId || this.warehouse || '').trim();
        if (wh !== '101') {
            return false;
        }
        const orderType = String(
            this.item?.orderTypeId ||
                this.item?.orderType ||
                this.product?.orderTypeId ||
                this.product?.orderType ||
                ''
        ).trim();
        return orderType !== 'G10' && orderType !== 'G11';
    }

    onWh101OrderTypeWarningOk(): void {
        this.wh101OrderTypeWarningVisible = false;
    }

    onCreditLimitConfirmCancel(): void {
        this.creditLimitDialogVisible = false;
        if (!this.creditLimitSaveConfirmAccepted) {
            this.setCustomerCreditBlockAfterSave = false;
        }
        this.creditLimitSaveConfirmAccepted = false;
    }

    onCreditLimitConfirmAccept(): void {
        this.creditLimitSaveConfirmAccepted = true;
        this.setCustomerCreditBlockAfterSave = true;
        this.creditLimitDialogVisible = false;
        this.submitOrderAfterValidations();
    }

    /** Copied draft is a new order: do not inherit source M3 sync or credit approval. */
    protected clearCopiedOrderCreditAndSyncFields(): void {
        for (const target of [this.item, this.product]) {
            if (!target) {
                continue;
            }
            target.referenceOrderId = '';
            target.creditLimitApproved = false;
            target.creditLimitApprovedBy = undefined;
            target.creditLimitApprovedAt = undefined;
            target.creditLimitApprovalReason = undefined;
            target.marginApproved = false;
            target.marginApprovedBy = undefined;
            target.marginApprovedAt = undefined;
            target.marginApprovalReason = undefined;
        }
    }

    private submitOrderAfterValidations(): void {
        if (this.guardMissingCustomerId('save order')) {
            return;
        }
        console.log('🔍 [ORDER VALIDATION] Starting order-level validation...');
        console.log('ITEM', this.item);
        console.log('PRODUCT', this.product);

        const customerId = this.item?.customerId || '';
        const company = this.company;
        const division = this.division;

        console.log('📋 [ORDER DETAILS]:', { customerId, company, division, itemCount: this.itemList.length });

        if (this.shouldValidateOrderMarginOnSave) {
            (this.itemList || []).forEach((line) => Object.assign(line, calculateRowAmounts(line)));

            if (this.isMarginApprovalEnabled) {
                // Save must not call ItemDetails — cost/MCM come from copy/excel/add only.
                this.ensureMarginDataThen(
                    () => {
                        if (this.handleMarginApprovalAction('Approve & Save Draft', () => this.finishSaveAfterValidations(), 'save')) {
                            return;
                        }
                        this.finishSaveAfterValidations();
                    },
                    { allowFetch: false }
                );
                return;
            } else {
                const orderMinimumMarginPercent = this.getOrderMinimumMarginPercent();
                if (orderMinimumMarginPercent > 0) {
                    const orderMargin = this.marginValidationService.calculateOrderContributionMargin(this.itemList);
                    if (orderMargin.actualOrderMarginPercent < orderMinimumMarginPercent) {
                        this.orderMarginDialogActual = orderMargin.actualOrderMarginPercent;
                        this.orderMarginDialogRequired = orderMinimumMarginPercent;
                        this.orderMarginDialogVisible = true;
                        return;
                    }
                }
            }
        }

        this.finishSaveAfterValidations();
    }

    /** Read optional UCA2 from header field; undefined when empty (skip API update on existing orders). */
    private resolveUca2ForSubmit(): string | undefined | null {
        if (String(this.division ?? '').trim() !== '100') {
            return undefined;
        }
        const trimmed = (this.item?.uca2 ?? this.product?.uca2 ?? '').toString().trim();
        if (trimmed.length > this.uca2MaxLength) {
            this.messageService.add({
                severity: 'error',
                summary: 'UCA2 too long',
                detail: `Extra information must be at most ${this.uca2MaxLength} characters.`,
                life: 4000
            });
            return null;
        }
        if (this.item) {
            this.item.uca2 = trimmed || undefined;
        }
        return trimmed || undefined;
    }

    private finishSaveAfterValidations(): void {
        const uca2 = this.resolveUca2ForSubmit();
        if (uca2 === null) {
            return;
        }
        this._proceedWithOrderSubmission(uca2);
    }

    /**
     * Continue with order submission after margin validation passes
     */
    private _proceedWithOrderSubmission(uca2?: string): void {
        if (this.loading || this.orderSaveInFlight) {
            return;
        }
        this.orderSaveInFlight = true;
        const setCustomerCreditBlockAfterSave = this.setCustomerCreditBlockAfterSave;
        this.setCustomerCreditBlockAfterSave = false;
        console.log('🚀 [ORDER SUBMISSION] All validations passed. Calling itemOrderHandler.submitOrder()');

        this.itemOrderHandler.submitOrder({
            item: this.item,
            itemList: this.itemList,
            company: this.company,
            division: this.division,
            product: this.product,
            salesPerson: this.salesPerson,
            loadingSetter: (val: boolean) => this.setOrderSaveLoading(val),
            loaderMessageSetter: (l1: string, l2: string) => {
                this.loaderMessageLine1 = l1;
                this.loaderMessageLine2 = l2;
            },
            getTotalValue: () => this.getTotalValue(),
            getTotalDiscountValue: () => this.getTotalDiscountValue(),
            getTotalNetAmount: () => this.getTotalNetAmount(),
            getTotalVatAmount: () => this.getTotalVatAmount(),
            getTotalWeight: () => this.getTotalWeight(),
            getSubscription: () => this.getSubscription(),
            creditNoteFromDispute: this.creditNoteFromDispute,
            punchFromQuotation: this.punchFromQuotation,
            uca2,
            setCustomerCreditBlockAfterSave,
            onOrderLinesSubmitted: (referenceOrderNumber: string, orderNumber: string) =>
                this.submitOrderLines(referenceOrderNumber, orderNumber)
        });
    }

    apiError: boolean = false;

    submitOrderLines(referenceOrderNumber: string, orderNumber: string) {
        console.log(this.itemList);
        console.log(this.itemList.length);

        const isDraftSave = this.isImmediateDivision;
        const minBusinessQty = 0.01;
        const minBusinessRate = 0.01;
        const invalidLines = (this.itemList || []).filter((line: any) => {
            if (!line || !line.itemNumber) {
                return false;
            }
            const qty = Number(line.quantity ?? 0);
            const rate = Number(line.rate ?? 0);
            if (this.isCreditNoteOrder) {
                return Math.abs(qty) <= minBusinessQty || rate <= minBusinessRate;
            }
            return qty <= minBusinessQty || rate <= minBusinessRate;
        });

        if (!isDraftSave && invalidLines.length) {
            this.setOrderSaveLoading(false);
            this.messageService.add({
                severity: 'error',
                summary: 'Cannot save',
                detail: this.isCreditNoteOrder
                    ? 'Quantity (absolute value) and rate must be greater than 0.01 for all lines before saving.'
                    : 'Quantity and rate must be greater than 0.01 for all lines before saving.',
                life: 4000
            });
            return;
        }

        this.itemOrderHandler.submitOrderLines({
            itemList: this.itemList,
            company: this.company,
            division: this.division,
            product: this.product,
            item: this.item,
            loadingSetter: (val: boolean) => this.setOrderSaveLoading(val),
            messageHandler: (msg) => this.messageService.add(msg),
            routerNavigate: (commands) => this.router.navigate(commands),
            getTotalValue: () => this.getTotalValue(),
            getTotalDiscountValue: () => this.getTotalDiscountValue(),
            getTotalNetAmount: () => this.getTotalNetAmount(),
            getTotalVatAmount: () => this.getTotalVatAmount(),
            getTotalWeight: () => this.getTotalWeight(),
            getSubscription: () => this.getSubscription(),
            clearDeletedItems: () => this.clearDeletedItems(),
            totalArticles: this.itemList.length,
            orderType: this.item.orderTypeId,
            requestedDate: this.item.requestedDate,
            orderNumber,
            referenceOrderNumber,
            onBulkLinesSuccess: this.resolveBulkLinesSuccessHandler()
        });
    }

    /**
     * Hook for V2 Sync-after-draft popup. V1 returns undefined (always redirect to Orders1).
     */
    protected resolveBulkLinesSuccessHandler(): ((orderNumber: string) => boolean | void) | undefined {
        return undefined;
    }

    getOrderType(): string {
        return this.item?.orderType || '';
    }

    getRequestedDate(): string {
        return this.item?.requestedDate || '';
    }
    clearDeletedItems() {
        console.log('Clearing deleted items tracking');
        this.deletedItems.clear();
    }

    /**
     * Navigates back to the display page.
     */
    goBack() {
        // const orderNumber = this.item?.orderNumber || '';
        // const companyId = this.company;
        // const divisionId = this.division;
        // const currentUsername = this.salesPerson;

        // this.itemOrderHandler.releaseOrderLock(orderNumber, companyId, divisionId, currentUsername).subscribe({
        //     next: () => this.router.navigate(['/Orders']),
        //     error: () => this.router.navigate(['/Orders'])
        this.router.navigate(['/Orders1']);
        // });
    }

    apiData: { CUNO: string; CUNM: string } = { CUNO: '', CUNM: '' };

    headerBody: any = {};

    /**
     * Fetches the order lines for the current order from the server.
     * Updates the item list with the fetched lines and sets their status to 20.
     */
    fetchOrderLines() {
        this.itemOrderHandler.fetchOrderLines({
            item: this.item,
            company: this.company,
            division: this.division,
            loadingSetter: (val: boolean) => (this.loading = val),
            loaderMessageSetter: (l1: string, l2: string) => {
                this.loaderMessageLine1 = l1;
                this.loaderMessageLine2 = l2;
            },
            itemListSetter: (list: any[]) => {
                this.itemList = list;
                this.refreshMarginFlagsOnItemList();
            },
            messageHandler: (msg) => this.messageService.add(msg)
        });
    }

    ngOnDestroy(): void {
        console.log('ngOnDestroy called');

        // Get the next URL from the router (if available)
        const nextUrl = this.router.getCurrentNavigation()?.finalUrl?.toString() || '';

        // If navigating to Invoice or Picking List, do NOT release the lock
        if (nextUrl.includes('/generate-invoice') || nextUrl.includes('/picking-list')) {
            // Just clear interval and destroy$
            if (this.lockRefreshInterval) {
                clearInterval(this.lockRefreshInterval);
            }
            this.destroy$.next();
            this.destroy$.complete();
            console.log('Component destroyed, lock not released (navigating to Invoice or Picking List)');
            return;
        }

        console.log(this.item);

        // Otherwise, release the lock as usual
        const orderNumber = this.item?.orderNumber || '';
        const companyId = this.company;
        const divisionId = this.division;
        const currentUsername = this.salesPerson;
        console.log(orderNumber, companyId, divisionId, currentUsername);

        if (orderNumber && companyId && divisionId && currentUsername) {
            this.itemDetailsService.releaseOrderLock(orderNumber, companyId, divisionId, currentUsername).subscribe({
                next: () => console.log('Order lock released on destroy'),
                error: () => console.warn('Failed to release lock on destroy'),
                complete: () => this.resetFields()
            });
        }

        if (this.lockRefreshInterval) {
            clearInterval(this.lockRefreshInterval);
        }
        this.destroy$.next();
        this.destroy$.complete();
        console.log('Component destroyed and order lock released');
    }
    get minRate(): number {
        // For NL series
        if (this.product?.pltb === 'GFT_NL_01') {
            const nl3 = this.priceLists.find((pl) => pl.name === 'NL3');
            return nl3 ? Number(nl3.value) : 0;
        }
        // For PL series
        if (this.product?.pltb === 'GFT01' || this.product?.pltb === 'GFT02') {
            const pl3 = this.priceLists.find((pl) => pl.name === 'PL3');
            return pl3 ? Number(pl3.value) : 0;
        }
        if (this.product?.pltb === 'GFT_FR_01') {
            const fr3 = this.priceLists.find((pl) => pl.name === 'FR3');
            return fr3 ? Number(fr3.value) : 0;
        }
        return 0;
    }

    get maxRate(): number {
        // For NL series
        if (this.product?.pltb === 'GFT_NL_01') {
            const nl1 = this.priceLists.find((pl) => pl.name === 'NL1');
            return nl1 ? Number(nl1.value) : 0;
        }
        // For PL series
        if (this.product?.pltb === 'GFT01' || this.product?.pltb === 'GFT02') {
            const pl1 = this.priceLists.find((pl) => pl.name === 'PL1');
            return pl1 ? Number(pl1.value) : 0;
        }
        if (this.product?.pltb === 'GFT_FR_01') {
            const fr1 = this.priceLists.find((pl) => pl.name === 'FR1');
            return fr1 ? Number(fr1.value) : 0;
        }
        return 0;
    }
    startLockRefresh() {
        // Call immediately once if needed
        this.refreshOrderLock();

        // Then every 30 sec
        this.lockRefreshInterval = setInterval(() => {
            this.refreshOrderLock();
        }, 30 * 1000); // 30 sec in ms
    }
    refreshOrderLock() {
        const orderNumber = this.item?.orderNumber || '';
        const companyId = this.company;
        const divisionId = this.division;
        const currentUsername = this.salesPerson;

        if (orderNumber && companyId && divisionId && currentUsername) {
            this.itemDetailsService.refreshOrderLock(orderNumber, companyId, divisionId, currentUsername).subscribe({
                next: (data) => {
                    console.log('Order lock refreshed.', data);
                    // this.messageService.add({ severity: 'info', summary: 'Lock Refreshed', detail: 'Order lock refreshed.' });
                },
                error: (err) => {
                    console.log('Error refreshing order lock:', err);
                    // this.messageService.add({ severity: 'warn', summary: 'Lock Refresh Failed', detail: 'Could not refresh lock.' });
                }
            });
        }
    }
}









